var StampedFn = StampedFn || function(L, A) {
    var s, P, q = {
            DEFAULT_ENDPOINT: L.stamped_ajax_url || "//stamped.io/api",
            SECURE_ENDPOINT: L.stamped_ajax_secure_url || "https://stamped.io/api",
            metafields: L.mainWidgetMetafields || "",
            exclude_main_css: L.stamped_exclude_main_css || !1,
            exclude_font: L.stamped_disable_font || !1,
            disable_single_review: L.stamped_disable_review_single || !1,
            is_preview: L.isStampedLauncherPreview || !1,
            modal_ugc_image_viewer: !0 !== L.stamped_modal_ugc_type_background ? "image" : "background",
            is_init_rewards: !0,
            referral_code: null,
            is_rewards_code_copy: !1,
            is_ignore_submit_error: !1
        },
        S = !1,
        r = !1;
    L.StampedGlobalOptions = {}, L.isInitializedStamped = !1;
    var k, d, a, l, n, o, p, m, c, u, g, h, v, t = [],
        f = [],
        w = [],
        _ = {},
        y = "div#stamped-main-widget",
        b = {},
        C = "html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video { margin: 0; padding: 0; border: 0; font-size: 100%; font: inherit; vertical-align: baseline; }";

    function I() {
        var e, t = !1;
        return e = navigator.userAgent || navigator.vendor || L.opera, (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(e.substr(0, 4))) && (t = !0), t
    }

    function D(e) {
        if ("click" === e.type) return !0;
        if ("keypress" !== e.type) return !1;
        var t = e.charCode || e.keyCode;
        return 32 === t || 13 === t || void 0
    }

    function e(e, t) {
        t = t || {
            bubbles: !1,
            cancelable: !1,
            detail: void 0
        };
        var a = A.createEvent("CustomEvent");
        return a.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), a
    }

    function R() {
        return (R = Object.assign || function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var a = arguments[t];
                for (var s in a) Object.prototype.hasOwnProperty.call(a, s) && (e[s] = a[s])
            }
            return e
        }).apply(this, arguments)
    }
    String.prototype.formatStringStamped = function() {
        for (var e = this, t = 0; t < arguments.length; t++) {
            var a = new RegExp("\\{" + t + "\\}", "gi");
            e = e.replace(a, arguments[t])
        }
        return e
    }, "function" != typeof L.CustomEvent && (e.prototype = L.Event.prototype, L.CustomEvent = e), L.lazyLoadOptions = {
        elements_selector: ".stamped-lazyload"
    }, L.addEventListener("LazyLoad::Initialized", function(e) {
        L.LazyLoadStamped = e.detail.instance
    }, !1);
    var T, O, x;
    ! function() {
        "use strict";

        function i(e, t) {
            var a, s = new e(t);
            try {
                a = new CustomEvent("LazyLoad::Initialized", {
                    detail: {
                        instance: s
                    }
                })
            } catch (e) {
                (a = A.createEvent("CustomEvent")).initCustomEvent("LazyLoad::Initialized", !1, !1, {
                    instance: s
                })
            }
            try {
                L.dispatchEvent(a)
            } catch (t) {}
        }

        function m(e, t) {
            return e.getAttribute("data-" + t)
        }

        function r(e, t, a) {
            var s = "data-" + t;
            null !== a ? e.setAttribute(s, a) : e.removeAttribute(s)
        }

        function d(e) {
            return "true" === m(e, "was-processed")
        }

        function c(e, t) {
            return r(e, "ll-timeout", t)
        }

        function u(e) {
            return m(e, "ll-timeout")
        }

        function g(e, t) {
            e && e(t)
        }

        function h(e, t) {
            e._loadingCount += t, 0 === e._elements.length && 0 === e._loadingCount && g(e._settings.callback_finish)
        }

        function s(e) {
            for (var t, a = [], s = 0; t = e.children[s]; s += 1) "SOURCE" === t.tagName && a.push(t);
            return a
        }

        function a(e, t, a) {
            a && e.setAttribute(t, a)
        }

        function n(e, t) {
            a(e, "sizes", m(e, t.data_sizes)), a(e, "srcset", m(e, t.data_srcset)), a(e, "src", m(e, t.data_src))
        }

        function l(e, t) {
            I ? e.classList.add(t) : e.className += (e.className ? " " : "") + t
        }

        function o(e, t, a) {
            e.addEventListener(t, a)
        }

        function p(e, t, a) {
            e.removeEventListener(t, a)
        }

        function v(e, t, a) {
            p(e, "load", t), p(e, "loadeddata", t), p(e, "error", a)
        }

        function f(e, t, a) {
            var s, i, r = a._settings,
                d = t ? r.class_loaded : r.class_error,
                n = t ? r.callback_loaded : r.callback_error,
                o = e.target;
            s = o, i = r.class_loading, I ? s.classList.remove(i) : s.className = s.className.replace(new RegExp("(^|\\s+)" + i + "(\\s+|$)"), " ").replace(/^\s+/, "").replace(/\s+$/, ""), l(o, d), g(n, o), h(a, -1)
        }

        function w(a, s) {
            function i(e) {
                f(e, !0, s), v(a, i, d)
            }
            var e, t, r, d = function e(t) {
                f(t, !1, s), v(a, i, e)
            };
            r = d, o(e = a, "load", t = i), o(e, "loadeddata", t), o(e, "error", r)
        }

        function y(e, t) {
            var a = t._observer;
            E(e, t), a && t._settings.auto_unobserve && a.unobserve(e)
        }

        function b(e) {
            var t = u(e);
            t && (clearTimeout(t), c(e, null))
        }

        function S(p) {
            return !!C && (p._observer = new IntersectionObserver(function(e) {
                e.forEach(function(e) {
                    return e.isIntersecting || 0 < e.intersectionRatio ? (s = e.target, l = (i = p)._settings, g(l.callback_enter, s), void(l.load_delay ? (r = s, n = (d = i)._settings.load_delay, (o = u(r)) || (o = setTimeout(function() {
                        y(r, d), b(r)
                    }, n), c(r, o))) : y(s, i))) : (t = e.target, a = p._settings, g(a.callback_exit, t), void(a.load_delay && b(t)));
                    var t, a, s, i, r, d, n, o, l
                })
            }, {
                root: (e = p._settings).container === A ? null : e.container,
                rootMargin: e.thresholds || e.threshold + "px"
            }), !0);
            var e
        }

        function k(e, t) {
            return (s = e || (a = t).container.querySelectorAll(a.elements_selector), Array.prototype.slice.call(s)).filter(function(e) {
                return !d(e)
            });
            var a, s
        }

        function e(e, t) {
            this._settings = R({}, T, e), this._loadingCount = 0, S(this), this.update(t)
        }
        var t = void 0 !== L,
            _ = t && !("onscroll" in L) || "undefined" != typeof navigator && /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent),
            C = t && "IntersectionObserver" in L,
            I = t && "classList" in A.createElement("p"),
            T = {
                elements_selector: "img",
                container: _ || t ? A : null,
                threshold: 300,
                thresholds: null,
                data_src: "src",
                data_srcset: "srcset",
                data_sizes: "sizes",
                data_bg: "bg",
                class_loading: "stamped-lazyload-loading",
                class_loaded: "stamped-lazyload-loaded",
                class_error: "stamped-lazyload-error",
                load_delay: 0,
                auto_unobserve: !0,
                callback_enter: null,
                callback_exit: null,
                callback_reveal: null,
                callback_loaded: null,
                callback_error: null,
                callback_finish: null,
                use_native: !1
            },
            O = {
                IMG: function(e, t) {
                    var a = e.parentNode;
                    a && "PICTURE" === a.tagName && s(a).forEach(function(e) {
                        n(e, t)
                    }), n(e, t)
                },
                IFRAME: function(e, t) {
                    a(e, "src", m(e, t.data_src))
                },
                VIDEO: function(e, t) {
                    s(e).forEach(function(e) {
                        a(e, "src", m(e, t.data_src))
                    }), a(e, "src", m(e, t.data_src)), e.load()
                }
            },
            x = ["IMG", "IFRAME", "VIDEO"],
            E = function(e, t, a) {
                var s = t._settings;
                !a && d(e) || (-1 < x.indexOf(e.tagName) && (w(e, t), l(e, s.class_loading)), function(e, t) {
                    var a, s, i, r, d, n, o = t._settings,
                        l = e.tagName,
                        p = O[l];
                    if (p) return p(e, o), h(t, 1), t._elements = (a = t._elements, s = e, a.filter(function(e) {
                        return e !== s
                    }));
                    d = m(i = e, (r = o).data_src), n = m(i, r.data_bg), d && (i.style.backgroundImage = 'url("'.concat(d, '")')), n && (i.style.backgroundImage = n)
                }(e, t), r(e, "was-processed", "true"), g(s.callback_reveal, e), g(s.callback_set, e))
            },
            U = ["IMG", "IFRAME"];
        e.prototype = {
            update: function(e) {
                var t, a = this,
                    s = this._settings;
                this._elements = k(e, s), !_ && this._observer ? (s.use_native && "loading" in HTMLImageElement.prototype && ((t = this)._elements.forEach(function(e) {
                    -1 !== U.indexOf(e.tagName) && (e.setAttribute("loading", "lazy"), E(e, t))
                }), this._elements = k(e, s)), this._elements.forEach(function(e) {
                    a._observer.observe(e)
                })) : this.loadAll()
            },
            destroy: function() {
                var t = this;
                this._observer && (this._elements.forEach(function(e) {
                    t._observer.unobserve(e)
                }), this._observer = null), this._elements = null, this._settings = null
            },
            load: function(e, t) {
                E(e, this, t)
            },
            loadAll: function() {
                var t = this;
                this._elements.forEach(function(e) {
                    y(e, t)
                })
            }
        }, t && function(e, t) {
            if (t)
                if (t.length)
                    for (var a, s = 0; a = t[s]; s += 1) i(e, a);
                else i(e, t)
        }(e, L.lazyLoadOptions)
    }();

    function E(e, t) {
        t ? (Ee("Using included jQ"), P = t, Ee(L.jQueryStamped = P)) : (Ee("Loaded jQ"), L.jQueryStamped = P), /msie/.test(L.navigator.userAgent.toLowerCase()) && (P.support.cors = !0), 1 != q.exclude_font && P("head").append(P("<link/>", {
            rel: "stylesheet",
            href: "//fonts.googleapis.com/css?family=Open+Sans:400,600&display=swap",
            type: "text/css"
        }));
        var a = xe("stamped_referral_code") || xe("stamped_ref");
        a && (Re("stamped_referral_code", {
            code: a
        }), q.referral_code = a);
        var s = Fe("stamped_referral_code");
        s && s.code && (q.referral_code = s.code), Ee("Library Starting..."), P.isReady ? U() : P(A).ready(function() {
            U()
        }), setTimeout(function() {
            r || (Ee("Library not started, fallback"), U())
        }, 3e3)
    }

    function U() {
        Ee("Started library"), Ke("stamped:init:starting"), F(), j(), r = !0
    }

    function F() {
        if (Ee("Starting UGC..."), (k = P(y)).length) {
            if (P.trim(k.html())) {
                Z(), ne(), se(), ae(), X(), ie();
                try {
                    L.LazyLoadStamped && LazyLoadStamped.update && LazyLoadStamped.update()
                } catch (e) {}
            } else Y();
            P(A).on("click keypress", ".stamped-summary-ratings .summary-rating", function(e) {
                if (!0 === D(e)) {
                    var t = P(this).find(".summary-rating-bar"),
                        a = t.attr("data-rating"),
                        s = t.hasClass("selected");
                    P(".stamped-summary-ratings .summary-rating").each(function() {
                        P(this).removeClass("selected")
                    }), P(".summary-rating-bar").each(function() {
                        P(this).removeClass("selected")
                    }), a && (s ? (Ce(1), P(".stamped-summary-ratings").removeClass("selected")) : (t.addClass("selected"), P(this).addClass("selected"), P(".stamped-summary-ratings").addClass("selected"), Ce(1, a)))
                }
            }), P(A).on("mouseover mouseout", ".stamped-form-review-rating a.fa", function(e) {
                var t, a, s;
                t = e.currentTarget, s = P(t).attr("data-value"), a = P(t).parent(), "mouseover" === e.type ? (a.find("a.fa:lt(" + s + ")").removeClass("fa-star-o").addClass("fa-star"), a.find("a.fa:gt(" + (s - 1) + ")").removeClass("spr-icon-star-hover").addClass("fa-star-o")) : a.find("a.fa").removeClass("fa-star").addClass("fa-star-o")
            }), P(A).on("click keypress", ".stamped-tabs li", function(e) {
                !0 === D(e) && ce(this)
            }), P(A).on("keypress", ".stamped-summary-actions-newreview", function(e) {
                !0 === D(e) && ke("reviews")
            }), P(A).on("keypress", ".stamped-summary-actions-newquestion", function(e) {
                !0 === D(e) && ke("reviews")
            }), P(A).on("click keypress", "#shopry-rating-wrapper a.shopry-thumbs-up, #shopry-rating-wrapper a.shopry-thumbs-down, #shopry-rating-holder a.shopry-thumbs-up, #shopry-rating-holder a.shopry-thumbs-down, #stamped-rating-holder a.stamped-thumbs-up, #stamped-rating-holder a.stamped-thumbs-down, .stamped-rating-holder a.stamped-thumbs-up, .stamped-rating-holder a.stamped-thumbs-down", function(e) {
                if (!0 === D(e)) {
                    var t = P(this).attr("data-review-id"),
                        a = P(this).attr("data-rating"),
                        s = k.attr("data-product-id"),
                        i = P(this);
                    i.parent().fadeTo("slow", .3), i.addClass("disable-link"), P.ajax({
                        type: "POST",
                        url: q.SECURE_ENDPOINT + "/reviews/vote",
                        data: {
                            productId: s,
                            reviewId: t,
                            vote: a,
                            apiKey: L.StampedGlobalOptions.apiKey,
                            sId: L.StampedGlobalOptions.sId,
                            storeUrl: L.StampedGlobalOptions.storeUrl
                        },
                        success: function(e) {
                            if (1 == e || -1 == e) {
                                var t = i.find(".stamped-fa").html();
                                t = t.replace("&nbsp;", "").trim();
                                var a = parseInt(t);
                                i.find(".stamped-fa").html("&nbsp; " + (a + e))
                            }
                            i.parent().fadeTo("slow", 1), i.removeClass("disable-link")
                        }
                    })
                }
            }), P(A).on("click keypress", ".stamped-share-button,.stamped-share-icon", function(e) {
                !0 === D(e) && P(this).parent().find(".stamped-share-links").fadeToggle()
            }), P(A).on("click keypress", ".stamped-summary-actions-mobile-filter", function(e) {
                if (!0 === D(e)) {
                    var t = P(".stamped-filters-wrapper");
                    t.hasClass("stamped-mobile-visible") ? (t.slideUp(), t.removeClass("stamped-mobile-visible")) : (t.slideDown(), t.addClass("stamped-mobile-visible"))
                }
            }), P(A).on("click keypress", ".stamped-summary-keywords-list li", function(e) {
                if (!0 === D(e)) {
                    var t = P(this);
                    t.hasClass("selected") ? (P(".stamped-summary-keywords-list li").removeClass("selected"), P(k).removeAttr("data-keyword")) : (P(".stamped-summary-keywords-list li").removeClass("selected"), t.addClass("selected"), P(k).attr("data-keyword", t.text().trim())), P(".stamped-summary-actions-clear").show(), Ce(1)
                }
            }), P(A).on("change keyup", ".stamped-reviews-search-input", function(e) {
                var t;
                (t = P(this).val()) ? (P(".stamped-reviews-search-clear").show(), P(".stamped-reviews", k).attr("data-filtered", "true")) : (P(".stamped-reviews-search-clear").hide(), P(".stamped-reviews", k).removeAttr("data-filtered")), 13 != e.keyCode || (t = P(this).val()) && (P(k).attr("data-search", t.trim()), P(".stamped-summary-actions-clear").show(), re(), Ce(1))
            }), P(A).on("click keypress", ".stamped-reviews-search-button", function(e) {
                if (!0 === D(event)) {
                    var t = P(".stamped-reviews-search-input").val();
                    t && (P(k).attr("data-search", t.trim()), P(".stamped-summary-actions-clear").show(), re(), Ce(1))
                }
            }), P(A).on("click keypress", ".stamped-summary-actions-clear", function(e) {
                !0 === D(e) && Ie()
            }), P(A).on("click keypress", ".stamped-reviews-search-clear", function(e) {
                !0 === D(e) && (P(".stamped-reviews-search-clear").hide(), P(".stamped-reviews-search-input").val(""), P(k).removeAttr("data-search"), Ce(1))
            }), P(A).one("stamped:reviews:loaded", function() {
                Ee("Main Widget event triggered reload once"), Z(), ne(), se(), ie(), xe("write_review") && ke("review"), xe("write_question") && ke("question")
            }), P(A).on("stamped:reviews:loaded", function(e) {
                Ee("Main Widget event triggered reload"), w = [], ae(), X();
                try {
                    L.LazyLoadStamped && LazyLoadStamped.update && LazyLoadStamped.update()
                } catch (e) {}
            })
        }
        P(A).one("stamped:launcher:loaded", function(e) {
            var t = xe("rewards-launcher");
            t && ("open" == t && K(), -1 < t.indexOf("view-") && (K(!0), V(t)))
        }), ee(), te();
        var e, t = xe("stamped_r_id");
        t && 1 != q.disable_single_review && (e = t, P.ajax({
            type: "GET",
            url: q.SECURE_ENDPOINT + "/widget/reviews",
            data: {
                reviewIds: e,
                apiKey: L.StampedGlobalOptions.apiKey,
                sId: L.StampedGlobalOptions.sId,
                storeUrl: L.StampedGlobalOptions.storeUrl,
                type: "single",
                showAvatar: "True",
                minRating: 1
            },
            success: function(e) {
                e.data.length && StampedFn.openUGCModal(e.data, 0, A, 1, !1, 0)
            },
            error: function(e) {}
        }))
    }

    function j(e) {
        Ee("Starting Rewards...");
        var t = P("#stamped-rewards-init");
        if (e && e.customer) return Ee("Started Rewards with direct data"), b = e, void G();
        e ? (Ee("Started Rewards with JS data"), b.customer = e, N()) : 0 < t.length ? (Ee("Started Rewards with div data"), b.customer = {
            customerId: t.data("customer-id"),
            customerEmail: t.data("customer-email"),
            customerFirstName: t.data("customer-first-name"),
            customerLastName: t.data("customer-last-name"),
            customerTags: t.data("customer-tags"),
            totalOrders: 0,
            totalSpent: 0,
            isAcceptMarketing: t.data("customer-accepts-marketing"),
            authToken: t.data("key-auth")
        }, N()) : Ee("Started Rewards no init customer data")
    }

    function N() {
        Ee("Loading Rewards API init...");
        var e = q.metafields || "";
        b && b.customer && e && (b.customer.metafields = e);
        var t = JSON.stringify(b.customer),
            a = q.is_test;
        P.ajax({
            type: "POST",
            url: q.SECURE_ENDPOINT + "/v2/rewards/init?" + P.param({
                apiKey: L.StampedGlobalOptions.apiKey,
                sId: L.StampedGlobalOptions.sId,
                storeUrl: L.StampedGlobalOptions.storeUrl,
                debug: null,
                isTest: a,
                isPreview: q.is_preview,
                referralCode: q.referral_code
            }),
            xhrFields: {
                withCredentials: !0
            },
            data: t,
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            success: function(e, t, a) {
                Ke("stamped:rewards:init"), b = e, G()
            }
        })
    }

    function G() {
        ! function() {
            if (!P("#stamped-rewards-init").length) {
                var e = A.createElement("div");
                e.setAttribute("id", "stamped-rewards-init"), A.body.appendChild(e)
            }
        }(), b && b.html && ((d = P("#stamped-rewards-init")).html(b.html.main), function() {
            n = P(".stamped-rewards-launcher", d), o = P(".stamped-launcher-button", d), c = P("<iframe>");
            var s = o.html();
            Ee("Func _buildIframeLauncher: width:" + o.width(), 1), Ee("Func _buildIframeLauncher: outerWidth:" + o.outerWidth(), 1), Ee("Func _buildIframeLauncher: var launcherWidth:" + (v = o.width() + 40), 1), o.width(v), o.html(c), n.hide(), setTimeout(function() {
                u = c[0].contentWindow.document, c[0].contentWindow.StampedFn = StampedFn, c[0].contentWindow.jQuery = jQuery;
                var e = P("body", u),
                    t = P("head", u);
                e.html(s), e.append(P("#stamped-rewards-main-css", d).clone()), t.append(P("<link/>", {
                    rel: "stylesheet",
                    href: "//cdn1.stamped.io/files/widget.min.css",
                    type: "text/css"
                }));
                var a = u.createElement("script");
                a.type = "text/javascript", a.src = "//kit.fontawesome.com/59de3073ed.js", a.setAttribute("data-observe-mutations", "true"), u.body.appendChild(a), t.append("<style>" + C + ' body { overflow:hidden; } .stamped-launcher-icon-opened { font-family:"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif; display:inline-block; width: 100%; margin-top: -2px; text-align:center;}</style>'), I() && e.attr("data-mobile", !0), p = P(".stamped-launcher-icon-closed", e), m = P(".stamped-launcher-icon-opened", e), setTimeout(function() {
                    n.fadeIn()
                }, 800)
            }, 800)
        }(), function() {
            a = P(".stamped-rewards-base", d), $launcherCss = P("#stamped-rewards-main-css", d).clone(), g = P("<iframe>");
            var i = a.html();
            a.html(g), setTimeout(function() {
                h = g[0].contentWindow.document, g[0].contentWindow.StampedFn = StampedFn, g[0].contentWindow.jQuery = jQuery;
                var e = P("body", h),
                    t = P("head", h);
                e.html(i), e.append(P("#stamped-rewards-main-css", d).clone()), t.append(P("<link/>", {
                    rel: "stylesheet",
                    href: "//cdn1.stamped.io/files/widget.min.css",
                    type: "text/css"
                })).append(P("<link/>", {
                    rel: "stylesheet",
                    href: "//fonts.googleapis.com/css?family=Open+Sans:400,600&display=swap",
                    type: "text/css"
                })), t.append("<script>window.FontAwesomeConfig = { searchPseudoElements: true };<\/script>");
                var a, s = h.createElement("script");
                s.type = "text/javascript", s.src = "//kit.fontawesome.com/59de3073ed.js", s.setAttribute("data-observe-mutations", "true"), s.setAttribute("data-search-pseudo-elements", "true"), h.body.appendChild(s), e.append("<style>" + C + ' .stamped-rewards-window { font-family:"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif; }</style>'), I() && e.attr("data-mobile", !0), b.customer && b.customer.customerEmail ? e.attr("data-logged-in", !0) : e.attr("data-logged-in", !1), 1 == b.branding && e.attr("data-branding", !0), $wrapperCards = P("#stamped-rewards-cards", h), $wrapperViews = P("#stamped-rewards-views", h), P(h).on("click", ".stamped-rewards-header-close", function() {
                    K()
                }), P(A).on("touchstart", function() {
                    a = !0
                }), P(A).on("touchmove", function() {
                    a = !1
                }), P(A).on("click touchend", function(e) {
                    if ("click" === e.type && (a = !0), a && !("stamped-rewards-init" === e.target.id || P(e.target).parents("#stamped-rewards-init").length || P(e.target).parents(".stamped-rewards-base").length || P(e.target).parents(".stamped-rewards-launcher").length || P(e.target).parents("#stamped-rewards-widget").length)) {
                        var t = P(".stamped-rewards-base", d).hasClass("opened");
                        setTimeout(function() {
                            t && StampedFn.toggleLauncher()
                        }, 300)
                    }
                }), P(h).on("click", '[data-campaign-completed="false"] .stamped-reward-card-button-earn', function() {
                    var s, i, e, r, d, t, n, a = P(this).parent(".stamped-rewards-card-earn"),
                        o = a.data("campaign-id"),
                        l = a.data("event-type");
                    if ("AccountBirthday" == l) {
                        var p = P(".stamped-rewards-birthday-input-holder", h);
                        p.show();
                        var m = P(".stamped-rewards-birthday-input-holder input", h).val();
                        m && (r = P(this), d = a, t = m, n = function() {
                            p.hide()
                        }, J(r, "loading", !0), P.ajax({
                            type: "POST",
                            url: q.SECURE_ENDPOINT + "/v2/rewards/addBirthday?" + P.param({
                                apiKey: L.StampedGlobalOptions.apiKey,
                                sId: L.StampedGlobalOptions.sId,
                                storeUrl: L.StampedGlobalOptions.storeUrl,
                                dateBirthday: t
                            }),
                            data: b.customer,
                            success: function(e, t, a) {
                                J(r, "active", !0, null, function() {
                                    d.attr("data-campaign-completed", "true")
                                }), n && n()
                            }
                        }))
                    } else "Review" == l || "ReviewPhoto" == l || "ReviewVideo" == l ? (P('.stamped-rewards-header-menu span[data-target="reviews"]', h).trigger("click"), V("main")) : (s = P(this), i = a, e = o, J(s, "loading", !0), P.ajax({
                        type: "POST",
                        url: q.SECURE_ENDPOINT + "/v2/rewards/add?" + P.param({
                            apiKey: L.StampedGlobalOptions.apiKey,
                            sId: L.StampedGlobalOptions.sId,
                            storeUrl: L.StampedGlobalOptions.storeUrl,
                            campaignId: e
                        }),
                        data: b.customer,
                        dataType: "json",
                        success: function(e, t, a) {
                            J(s, "active", !0, null, function() {
                                1 == e && i.attr("data-campaign-completed", "true")
                            }), M()
                        }
                    }), "SocialFollowInstagram" != l && "SocialFollowFacebook" != l && "SocialShareFacebook" != l && "SocialFollowTwitter" != l && "SocialShareTwitter" != l && "SocialYouTube" != l || function(e) {
                        var t = b.links;
                        if ("SocialFollowInstagram" == e) {
                            L.open(t.instagram, "_blank").focus()
                        } else if ("SocialFollowFacebook" == e) L.open("https://www.facebook.com/plugins/page.php?href=" + t.facebook, "_blank", "location=yes,height=250,width=340,top=50,left=50,scrollbars=yes,status=yes");
                        else if ("SocialShareFacebook" == e) L.open("https://www.facebook.com/sharer/sharer.php?u=" + t.shop, "_blank", "location=yes,height=500,width=500,top=50,left=50,scrollbars=yes,status=yes");
                        else if ("SocialFollowTwitter" == e) {
                            L.open(t.twitter, "_blank").focus()
                        } else "SocialShareTwitter" == e ? L.open("https://twitter.com/intent/tweet?url=" + t.shop, "_blank", "location=yes,height=500,width=500,top=50,left=50,scrollbars=yes,status=yes") : "SocialYouTube" == e && L.open(t.youtube, "_blank")
                    }(l))
                }), P(h).on("click", '[data-campaign-redeemable="true"] .stamped-reward-card-button-spend', function() {
                    var e = P(this).parent(".stamped-rewards-card-spend"),
                        t = e.data("campaign-id");
                    "Variable" == e.data("coupon-type") ? V("view-redeem-variable", null, {
                        entityId: t
                    }) : W(P(this), {
                        campaignId: t
                    }, function(e) {
                        V("view-coupon", null, e.rewardCampaignCoupon), M()
                    })
                }), P(h).on("click", ".stamped-reward-referral-platforms button", function() {
                    var e, t = P(this).attr("href");
                    t && (e = t, L.open(e, "_blank", "location=yes,height=500,width=500,top=50,left=50,scrollbars=yes,status=yes"))
                }), P(h).on("click", ".stamped-rewards-header-menu span", function() {
                    var e = P(this).attr("data-target");
                    e != $wrapperCards.attr("data-target") && ($wrapperCards.attr("data-target", e), z(e), P(".stamped-rewards-content-container", h).scrollTop(0), P(".stamped-rewards-header-menu .active", h).removeClass("active"), P(this, h).addClass("active"))
                }), P(".stamped-rewards-content-container", h).on("scroll", function() {
                    var e = P(".stamped-rewards-content-container", h).scrollTop(),
                        t = P(".stamped-rewards-header-content", h).outerHeight() + 15;
                    P(".stamped-rewards-header", h).css("min-height", "70px");
                    var a = 200;
                    a -= e, P(".stamped-rewards-background", h).height(a);
                    var s = t;
                    s -= e, P(".stamped-rewards-header", h).height(s)
                }), z("rewards"), Ke("stamped:launcher:loaded")
            }, 1e3)
        }(), function() {
            var e = b;
            if (P("#stamped-rewards-points-placeholder").html(e.points.points_current_with_name).attr("onclick", "StampedFn.toggleRewardsModal();"), P('#stamped-rewards-points-placeholder[data-type="points-only"]').html(e.points.points).attr("onclick", "StampedFn.toggleRewardsModal();"), 0 < P("#stamped-rewards-widget").length) {
                var s = [],
                    i = 1;
                P("[id=stamped-rewards-widget]").each(function(e) {
                    var t = P(this);
                    t.attr("data-element-id", i);
                    var a = he(t);
                    s.push(a), i++
                }), ve("rewards", s)
            }
        }())
    }

    function K(e) {
        var t = a.hasClass("opened");
        P("body", h).addClass("opened"), t ? 1 != e && (Ee("Func _toggleRewardsModal: var launcherWidth:" + v, 1), a.removeClass("opened"), a.fadeOut(), n.removeClass("opened"), p.removeClass("rotateIn"), p.addClass("rotateOut"), m.removeClass("fadeOut"), m.addClass("fadeIn"), o.animate({
            width: v + "px"
        }, 0), setTimeout(function() {
            V("main")
        }, 1e3), Ke("stamped:launcher:closed")) : (setTimeout(function() {
            a.addClass("opened")
        }, 100), n.addClass("opened"), a.fadeIn(), p.addClass("rotateIn"), p.removeClass("rotateOut"), m.addClass("fadeOut"), m.removeClass("fadeIn"), o.animate({
            width: "40px"
        }, 0), P(".stamped-rewards-content-container", h).scrollTop(0), P(".stamped-rewards-header", h).css("height", "auto"), Ke("stamped:launcher:opened"), "true" != ye("stamped-launcher-opened") && (P.ajax({
            type: "POST",
            url: q.SECURE_ENDPOINT + "/tracking/event?" + P.param({
                apiKey: L.StampedGlobalOptions.apiKey,
                sId: L.StampedGlobalOptions.sId,
                storeUrl: L.StampedGlobalOptions.storeUrl,
                source: "launcher",
                event: "open"
            }),
            dataType: "json",
            success: function(e, t, a) {
                console.log(e)
            }
        }), we("stamped-launcher-opened", !0, 1)))
    }

    function M(s) {
        P.ajax({
            type: "POST",
            url: q.SECURE_ENDPOINT + "/v2/rewards/points?" + P.param({
                apiKey: L.StampedGlobalOptions.apiKey,
                sId: L.StampedGlobalOptions.sId,
                storeUrl: L.StampedGlobalOptions.storeUrl
            }),
            data: b.customer,
            dataType: "json",
            success: function(e, t, a) {
                setTimeout(function() {
                    P(".stamped-rewards-header-main-points, .stamped-rewards-header-small-points", h).html(e.points_current_with_name)
                }, 5e3), s && s(e)
            }
        })
    }

    function W(s, i, r) {
        J(s, "loading", !0), i = i || {}, P.ajax({
            type: "POST",
            url: q.SECURE_ENDPOINT + "/v2/rewards/redeem?" + P.param({
                apiKey: L.StampedGlobalOptions.apiKey,
                sId: L.StampedGlobalOptions.sId,
                storeUrl: L.StampedGlobalOptions.storeUrl,
                campaignId: i.campaignId,
                points: i.points
            }),
            data: b.customer,
            dataType: "json",
            success: function(e, t, a) {
                i.campaignId && J(s, "active", !0, 1), r && r(e)
            }
        })
    }

    function z(e) {
        $wrapperCards.html(""), P("body", h).attr("data-view", e);
        for (var t = 0; t < b.html.cards.length; t++) {
            var a = b.html.cards[t];
            if (a && a.html && e == a.type) {
                var s = P(a.html);
                s.attr("data-key", a.key), $wrapperCards.append(s)
            }
        }
    }

    function V(s, e, i) {
        l = P(".stamped-rewards-window", h), P(".stamped-rewards-content-container", h).scrollTop(0), P(".stamped-rewards-header-nav", h).attr("onclick", "StampedFn.loadLauncherView('main');"), P("body", h).attr("data-view", s);
        var r = P(e).attr("data-title");
        if (l)
            if ("main" == s) {
                l.removeClass("stamped-rewards-nav-small"), l.addClass("stamped-rewards-nav-big"), P(".stamped-rewards-header-main, .stamped-rewards-header-menu", h).fadeIn(), P(".stamped-rewards-header-small", h).hide();
                var t = P(".stamped-rewards-header-content", h).outerHeight() + 15;
                P(".stamped-rewards-header", h).height(t), P(".stamped-rewards-background", h).height("200"), $wrapperViews.hide(), $wrapperCards.fadeIn()
            } else {
                for (var a = !1, d = 0; d < b.html.views.length; d++) {
                    var n = b.html.views[d];
                    n.key == s && (n.title && (r = n.title), a = !0, B(n.html), H(s, r, i))
                }
                if (!a) {
                    B(), H(s, r, i);
                    var o = null;
                    i && i.entityId && (o = i.entityId), P.ajax({
                        type: "POST",
                        url: q.SECURE_ENDPOINT + "/v2/rewards/cardview?" + P.param({
                            apiKey: L.StampedGlobalOptions.apiKey,
                            sId: L.StampedGlobalOptions.sId,
                            storeUrl: L.StampedGlobalOptions.storeUrl,
                            viewKey: s,
                            entityId: o,
                            referralCode: q.referral_code
                        }),
                        data: b.customer,
                        dataType: "json",
                        success: function(e, t, a) {
                            e && e.html ? (b.html.views.push(e), setTimeout(function() {
                                B(e.html, !1), H(s, e.title || r, i)
                            }, 1e3)) : V("main")
                        },
                        error: function() {
                            V("main")
                        }
                    })
                }
            }
    }

    function B(e, t) {
        if (e) {
            var a = P(e);
            $wrapperViews.html(a), $wrapperViews.removeClass("loading")
        } else $wrapperViews.html(""), P(".stamped-view-loader", $wrapperViews).length || $wrapperViews.append(P('<div class="stamped-view-loader"></div>')), $wrapperViews.addClass("loading");
        0 != t && (l.addClass("stamped-rewards-nav-small"), l.removeClass("stamped-rewards-nav-big"), P(".stamped-rewards-header-main, .stamped-rewards-header-menu", h).hide(), P(".stamped-rewards-header-small", h).fadeIn(), $wrapperCards.hide(), $wrapperViews.fadeIn())
    }

    function H(e, t, s) {
        var a, i, r = (s ? s.viewTitle : t) || t;
        if ("view-coupon" == e && (P(".stamped-reward-coupon-code", $wrapperViews).text(s.couponCode), P(".stamped-reward-card-title", $wrapperViews).html(s.title), a = "view-your-rewards", P(".stamped-rewards-header-nav", h).attr("onclick", "StampedFn.loadLauncherView('" + a + "');")), "view-earnings" == e && b && b.customer) {
            var d = P('[data-event-type="AccountBirthday"]', h);
            if (d.length) b.customer.dateBirthday ? d.attr("data-birthday", "true") : (d.attr("data-birthday", "false"), d.prepend(P('<div class="stamped-rewards-birthday-input-holder"> Enter your birthday: <input type="date" class="stamped-rewards-birthday-input" placeholder="yyyy-mm-dd" /> </div>').hide()))
        }
        if ("view-redeem-variable" == e) {
            if ($selectorInput = P(".range-slider__range", $wrapperViews), $selectorInput.length) {
                var n = $selectorInput.data("format-points"),
                    o = $selectorInput.data("format-points-name"),
                    l = $selectorInput.data("currency"),
                    p = $selectorInput.attr("step"),
                    m = $selectorInput.data("discount-value");

                function c() {
                    var e = $selectorInput.val(),
                        t = e / p * m,
                        a = new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: l
                        });
                    P("#redeem-points", $wrapperViews).text(n.formatStringStamped(e, o)), P("#redeem-amount", $wrapperViews).text(a.format(t))
                }
                $selectorInput.on("input", function() {
                    c()
                }), P(".stamped-rewards-content-action-button ", $wrapperViews).on("click", function() {
                    var e, t, a;
                    e = this, t = $selectorInput.val(), a = {
                        campaignId: s.entityId,
                        points: t
                    }, StampedFn.rewardsRedeem($(e), a, function(e) {
                        var t = e.rewardCampaignCoupon.couponCode,
                            a = e.rewardCampaignCoupon.title;
                        V("view-coupon", null, {
                            couponCode: t,
                            title: a,
                            viewTitle: a
                        })
                    })
                }), c()
            }
        }
        r && (i = r, P(".stamped-rewards-header-small-title", h).text(i))
    }

    function Q(e) {
        J(P("#stamped-rewards-apply-code", h), e)
    }

    function J(t, e, a, s, i) {
        if ("loading" == e) {
            var r = t.width();
            t.attr("data-original-text", t.text()), t.addClass("stamped-button-disabled"), 10 <= r && t.width(r), t.html('<span class="stamped-button-icon stamped-button-loading"></span>')
        } else a || t.html('<span class="stamped-button-icon stamped-button-completed"></span>'), setTimeout(function() {
            var e = t.attr("data-original-text");
            t.html(e), t.removeClass("stamped-button-disabled"), t.width("auto"), i && i()
        }, s || 7878)
    }

    function X() {
        Ee("Func initWidgetType");
        var e = P(".stamped-container", k).attr("data-widget-style");
        if ("slider" == e) {
            Ee(x = P(".stamped-reviews", k), 1);
            var t = x && x.hasClass("slick-initialized");
            if (Ee("Func initWidgetType: var initialized:" + t, 1), t) {
                P(".stamped-reviews > .stamped-review", k).each(function(e, t) {
                    x.slick("slickAdd", t)
                });
                P('.stamped-reviews [class*="stamped-review"]', k).length <= 0 ? P("button.slick-arrow").hide() : P("button.slick-arrow").show()
            } else Ue("https://cdn.shopify.com/s/files/1/0638/7747/files/slick.min.js", function() {
                x.slick({
                    dots: !1,
                    infinite: !1,
                    speed: 300,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    slide: ".stamped-review",
                    initialSlide: 0,
                    rows: 0,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                }), x.on("afterChange", function(e, t, a) {
                    if (P(".slick-next.slick-arrow").hasClass("slick-disabled")) {
                        0;
                        var s = P(".stamped-pagination .next a");
                        s.length && s.click()
                    }
                })
            })
        } else if ("masonry" == e) {
            var a = {
                3000: 2,
                1008: 1
            };
            L.macyInstanceConfig && L.macyInstanceConfig.breakAt && (a = L.macyInstanceConfig.breakAt), Ue("//s3-us-west-2.amazonaws.com/stamped.io/cdn/js/macy2.js", function() {
                L.macyInstanceStamped = Macy({
                    container: ".stamped-reviews",
                    margin: {
                        x: 50,
                        y: 50
                    },
                    breakAt: a
                }), Ke("stamped:macy:loaded")
            })
        }
        if (P(".stamped-sort-select").length) {
            var s = k.attr("data-sort") || P(".stamped-container", k).attr("data-widget-sort");
            s && "none" !== P('.stamped-sort-select option[value="' + s + '"]').css("display") && P(".stamped-sort-select").val(s)
        }
    }

    function Y(e) {
        k && k.length && !e || (k = P(y)), le()
    }

    function Z() {
        Ee("Creating Q&A"), me()
    }

    function ee() {
        ! function() {
            var e;
            if (Ee("Loading Badges..."), (t = P(".stamped-product-reviews-badge[data-id]")).length && (e = P.map(t, function(e) {
                    if (!P.trim(P(e).html()) || P(e).attr("data-type") || P(e).attr("data-product-type") || P(e).attr("data-product-sku") || P(e).attr("data-product-title")) return {
                        productId: P(e).attr("data-id"),
                        productType: P(e).attr("data-product-type"),
                        productSKU: P(e).attr("data-product-sku") || P(e).attr("data-product-sku2"),
                        productTitle: P(e).attr("data-product-title")
                    }
                })) && e.length) {
                JSON.stringify(e);
                P.ajax({
                    type: "POST",
                    dataType: "json",
                    contentType: "application/json",
                    url: q.SECURE_ENDPOINT + "/widget/badges",
                    data: JSON.stringify({
                        productIds: e,
                        apiKey: L.StampedGlobalOptions.apiKey,
                        sId: L.StampedGlobalOptions.sId,
                        storeUrl: L.StampedGlobalOptions.storeUrl
                    }),
                    success: function(i) {
                        t.each(function(e) {
                            var a = P(this).attr("data-id"),
                                t = P(this).attr("data-type"),
                                s = P.map(i, function(e, t) {
                                    if (e.productId == a) return t
                                })[0];
                            0 <= s && (!t || "review" == t) ? P(this).html(i[s].badge) : 0 <= s && "qna" == t && P(this).html(i[s].badgeqna)
                        }), Ke("stamped:badges:loaded")
                    },
                    error: function(e) {}
                })
            }
            P(".stamped-product-reviews-badge[data-id].stamped-main-badge, .stamped-product-reviews-badge:first").length && P(A).on("click", ".stamped-product-reviews-badge[data-id].stamped-main-badge, .stamped-product-reviews-badge:first", function() {
                "qna" === P(this).attr("data-type") ? (P("#stamped-questions-placeholder").length ? Se("#stamped-questions-placeholder") : (ce(null, "questions"), Se(y)), !P(".stamped-badge-caption[data-questions]").length || "0" === P(".stamped-badge-caption[data-questions]").attr("data-questions") && P(".new-question-form").show()) : (ce(null, "reviews"), Se(y))
            })
        }()
    }

    function te() {
        if (0 < P("#stamped-reviews-widget").length) {
            var s = [],
                i = 1;
            P("[id=stamped-reviews-widget]").each(function(e) {
                var t = P(this);
                t.attr("data-element-id", i);
                var a = he(t);
                s.push(a), i++
            }), ve("ugc", s)
        }
    }

    function ae() {
        var r = P(k).attr("data-limit-words") || P(".stamped-container", k).attr("data-widget-limit-words"),
            d = P(k).attr("data-keyword"),
            n = P(k).attr("data-search");
        (r && 0 < r || d || n) && P(".stamped-review", k).each(function(e) {
            var t = P(".stamped-review-content-body:first", this);
            if (t.length) {
                var a = P(t).html();
                if (a.indexOf("stamped-review-read-more") <= -1)
                    if (d || n) {
                        var s;
                        d && (s = pe(a, d)), n && (s = pe(a, n)), P(t).html(s)
                    } else {
                        var i = a.split(" ");
                        i.length > r && (txtTrimmed = i.slice(0, r).join(" ") + "...", P(t).html(txtTrimmed), P(t).append('<a class="stamped-review-read-more" style="margin-left:10px; cursor:pointer;">read more</span>'), P(t).append('<span class="original-review" style="display:none !important;">' + a + "</span>"))
                    }
            }
        }), P(".stamped-review-reply .stamped-review-reply-body, .stamped-review-reply .stamped-review-content-body").each(function() {
            if (!P(this).attr("data-link-processed")) {
                P(this).attr("data-link-processed", !0);
                var e = P(this).html();
                P(this).html(e.linkify())
            }
        })
    }

    function se() {
        var e = P(k).attr("data-keywords");
        if (e) {
            P(".stamped-reviews-filter-label").show(), P(".stamped-summary-keywords").show(), P(k).removeAttr("data-keywords"), P(".stamped-summary-keywords-list", k).html("");
            var t = "",
                a = e.split(",");
            for (i = 0; i < a.length; i++) t += "<li>" + a[i] + "</li>";
            P(t).appendTo(P(".stamped-summary-keywords-list", k))
        }
    }

    function ie() {
        P(A).on("click keypress", ".stamped-review-read-more", function(e) {
            if (!0 === D(e)) {
                P(this).closest(".stamped-review-content-body").find(".stamped-review-read-more").hide();
                var t = P(this).closest(".stamped-review-content-body").find(".original-review").html();
                P(this).closest(".stamped-review-content-body").html(t), L.macyInstanceStamped && L.macyInstanceStamped.reInit()
            }
        })
    }

    function re() {
        P(".stamped-summary-ratings").removeClass("selected"), P(".stamped-summary-ratings .summary-rating").each(function() {
            P(this).removeClass("selected")
        }), P(".summary-rating-bar").each(function() {
            P(this).removeClass("selected")
        })
    }
    T = void 0 !== L ? L : this, O = function() {
        function a(e) {
            return e instanceof Date ? e : isNaN(e) ? /^\d+$/.test(e) ? new Date(d(e)) : (e = (e || "").trim().replace(/\.\d+/, "").replace(/-/, "/").replace(/-/, "/").replace(/(\d)T(\d)/, "$1 $2").replace(/Z/, " UTC").replace(/([\+\-]\d\d)\:?(\d\d)/, " $1$2"), new Date(e)) : new Date(d(e))
        }

        function d(e) {
            return parseInt(e)
        }

        function o(e, t, a) {
            t = p[t] ? t : p[a] ? a : "en";
            for (var s = 0, i = e < 0 ? 1 : 0, r = e = Math.abs(e); m[s] <= e && s < 6; s++) e /= m[s];
            return (0 === (s *= 2) ? 9 : 1) < (e = d(e)) && (s += 1), p[t](e, s, r)[i].replace("%s", e)
        }

        function l(e, t) {
            return ((t = t ? a(t) : new Date) - a(e)) / 1e3
        }

        function r(e, t) {
            return e.getAttribute ? e.getAttribute(t) : e.attr ? e.attr(t) : void 0
        }

        function s(e, t) {
            this.nowDate = e, this.defaultLocale = t || "en"
        }

        function e(e, t) {
            return new s(e, t)
        }
        var i = "second_minute_hour_day_week_month_month".split("_"),
            n = "秒_分钟_小时_天_周_月_年".split("_"),
            p = {
                en: function(e, t) {
                    if (0 === t) return ["just now", "right now"];
                    var a = i[parseInt(t / 2)];
                    return 1 < e && (a += "s"), [e + " " + a + " ago", "in " + e + " " + a]
                },
                zh_CN: function(e, t) {
                    if (0 === t) return ["刚刚", "片刻后"];
                    var a = n[parseInt(t / 2)];
                    return [e + a + "前", e + a + "后"]
                }
            },
            m = [60, 60, 24, 7, 365 / 7 / 12, 1],
            c = "datetime",
            u = "data-tid",
            g = {};
        return s.prototype.doRender = function(e, t, a) {
            var s, i, r, d = l(t, this.nowDate),
                n = this;
            e.innerHTML = o(d, a, this.defaultLocale), g[s = setTimeout(function() {
                n.doRender(e, t, a), delete g[s]
            }, Math.min(1e3 * function(e) {
                for (var t = 1, a = 0, s = Math.abs(e); m[a] <= e && a < 6; a++) e /= m[a], t *= m[a];
                return s = (s %= t) ? t - s : t, Math.ceil(s)
            }(d), 2147483647))] = 0, r = s, (i = e).setAttribute ? i.setAttribute(u, r) : i.attr && i.attr(u, r)
        }, s.prototype.formatDateString = function(e, t) {
            return o(l(e, this.nowDate), t, this.defaultLocale)
        }, s.prototype.render = function(e, t) {
            void 0 === e.length && (e = [e]);
            for (var a = 0, s = e.length; a < s; a++) this.doRender(e[a], (i = e[a]).dataset.timeagoStamped ? i.dataset.timeagoStamped : r(i, c), t);
            var i
        }, s.prototype.setLocale = function(e) {
            this.defaultLocale = e
        }, e.register = function(e, t) {
            p[e] = t
        }, e.cancel = function(e) {
            var t;
            if (e)(t = r(e, u)) && (clearTimeout(t), delete g[t]);
            else {
                for (t in g) clearTimeout(t);
                g = {}
            }
        }, e
    }, "object" == typeof module && module.exports ? (module.exports = O(), module.exports.default = module.exports) : T.timeagoStamped = O();
    var de = 0;

    function ne() {
        if (L.File && L.FileReader && L.FormData) {
            var i = P("#stamped-file-uploader-input");
            i.on("change", function(e) {
                for (var t = e.target.files, a = 0; a < t.length; a++) {
                    var s = t[a];
                    if (s)
                        if (/^image\//i.test(s.type)) {
                            if (console.log("is image, begin upload"), 3 <= de) return void Ke("stamped:photo:maxed");
                            r(s, ++de)
                        } else Ke("stamped:photo:invalid"), console.log("Not a valid image!")
                }
                i.val("")
            }), P(A).on("click", ".stamped-file-photo-remove", function() {
                var e = P(this).attr("data-index");
                f.splice(e, 1), P('.stamped-file-photo[data-index="' + e + '"]').remove()
            })
        } else console.log("File upload is not supported!");

        function r(t, a) {
            var s = new FileReader;
            s.onloadend = function() {
                var d, n, o, e, l;
                console.log("process file"), d = s.result, n = t.type, o = t.name, e = a, (l = new Image).src = d, l.onload = function(e) {
                    var t = l.width,
                        a = l.height;
                    if (2500 < t || 2500 < a) {
                        var s, i;
                        a < t ? (i = a * (2500 / t), s = 2500) : (s = t * (2500 / a), i = 2500);
                        var r = A.createElement("canvas");
                        r.width = s, r.height = i, r.getContext("2d").drawImage(this, 0, 0, s, i), d = r.toDataURL(n), P(".stamped-file-holder").append('<div class="stamped-file-photo" data-index="' + e + '"><i class="fa fa-spin fa-spinner" /><img src="' + d + '" width="70" /><span style="display:none;">' + o + '</span><div class="stamped-file-photo-remove" data-index="' + e + '">x</div></div>'), p(d, e)
                    } else P(".stamped-file-holder").append('<div class="stamped-file-photo" data-index="' + e + '"><i class="fa fa-spin fa-spinner" /><img src="' + d + '" width="70" /><span style="display:none;">' + o + '</span><div class="stamped-file-photo-remove" data-index="' + e + '">x</div></div>'), p(d, e)
                }(e), l.onerror = function() {
                    console.log("There was an error processing your file!")
                }
            }, s.onerror = function() {
                console.log("There was an error reading the file!")
            }, s.readAsDataURL(t)
        }

        function p(e, t) {
            var a = k.attr("data-product-id"),
                s = {
                    imagea: e.replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")
                };
            Ke("stamped:photo:uploading"), P(".stamped-button-primary", k).attr("disabled", "disabled"), P.ajax({
                type: "POST",
                url: "//stamped.io/api/widget/upload?" + P.param(be({
                    productId: a,
                    apiKey: L.StampedGlobalOptions.apiKey,
                    sId: L.StampedGlobalOptions.sId,
                    storeUrl: L.StampedGlobalOptions.storeUrl
                })),
                data: JSON.stringify(s),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function(e) {
                    setTimeout(function() {
                        e && (f.push(e), d(e, t))
                    }, 1e3), setTimeout(function() {
                        Ke("stamped:photo:uploaded"), P(".stamped-button-primary", k).removeAttr("disabled")
                    }, 2e3)
                },
                error: function(e) {
                    f.length;
                    '"max"' == e.responseText ? alert("Upload up to 3 images") : console.log("An error occured, please try again later."), setTimeout(function() {
                        Ke("stamped:photo:uploaded"), P(".stamped-button-primary", k).removeAttr("disabled")
                    }, 2e3)
                }
            })
        }
        var d = function(e, t) {
            Ee("Photo upload complete idx" + t), P(".stamped-file-photo[data-index=" + t + "] .fa").remove()
        }
    }
    var oe = null;

    function le(p, m, e, t) {
        if (k.length && !S) {
            Ee("Loading Main Widget...");
            var a = k.attr("data-product-id"),
                s = k.attr("data-product-ids"),
                i = k.attr("data-name"),
                r = k.attr("data-product-type"),
                d = k.attr("data-product-sku"),
                n = k.attr("data-user-reference"),
                o = k.attr("data-take-reviews"),
                l = k.attr("data-keyword"),
                c = k.attr("data-widget-language"),
                u = (k.attr("data-widget-type"), k.attr("data-load-type") || P(".stamped-container", k).attr("data-widget-load-type")),
                g = k.attr("data-search"),
                h = k.attr("data-cache") || null,
                v = P(".stamped-container", k).attr("data-widget-style"),
                f = q.metafields;
            "slider" == v && (u = "continue"), i = i && i.replace("!", ""), m = m || (k.attr("data-sort") || P(".stamped-container", k).attr("data-widget-sort")), "continue" === u && (t = !0), P("#stamped-main-widget-placeholder").length && P("#stamped-main-widget-placeholder").append(k), S = !0, p && !t && Se(".stamped-reviews"), k.addClass("stamped-main-widget-loading");
            var w = P.param(be({
                productId: a,
                productIds: s,
                productName: i,
                productType: r,
                productSKU: d,
                userReference: n,
                page: p || 1,
                apiKey: L.StampedGlobalOptions.apiKey,
                sId: L.StampedGlobalOptions.sId,
                storeUrl: L.StampedGlobalOptions.storeUrl,
                take: o || 5,
                sort: m,
                rating: e,
                keyword: l,
                widgetLanguage: c,
                search: g,
                isUseCache: h
            }));
            P.isEmptyObject(_) || (w += "&" + P.param(_));
            var y = f.length,
                b = {
                    type: y ? "POST" : "GET",
                    data: y ? JSON.stringify({
                        metafields: f
                    }) : null,
                    dataType: "json",
                    url: q.SECURE_ENDPOINT + "/widget" + (y ? "/preview" : "") + "?" + w,
                    success: function(e) {
                        Ee("Loaded Main Widget..."), S = !1, k.removeClass("stamped-main-widget-loading");
                        var t, a = e.product,
                            s = e.widget,
                            i = P("#stamped-main-widget .stamped-container").length;
                        P(".question-form-wrapper").clone(), P(".stamped-questions").clone();
                        if (i || k.empty().html(a), t = "function" == typeof P.parseHTML ? P.parseHTML(s) : P(s), 0 == P(".stamped-content", k).children().length) P(".stamped-content", k).append(P(t));
                        else {
                            var r = P(".stamped-reviews", k),
                                d = P('[class="stamped-review"]', t);
                            ("continue" !== u || 1 === p && p) && P('.stamped-reviews [class*="stamped-review"]', k).remove();
                            var n = P(".stamped-pagination", t).attr("data-page", p),
                                o = P(".stamped-reviews .stamped-pagination", k);
                            o.length ? P(d).insertBefore(o) : P(d).appendTo(".stamped-reviews", k);
                            var l = P(".stamped-tabs", t);
                            P(".stamped-tabs", k).replaceWith(l), n.length ? o.length ? o.replaceWith(n) : r.append(n) : o.remove()
                        }
                        m && P(".stamped-sort-select", k).length && "none" !== P('.stamped-sort-select option[value="' + m + '"]', k).css("display") && (P(".stamped-sort-select", k).val(m), P(".stamped-container", k).attr("data-widget-sort", m)), P(".new-review-form").hide(), P(".new-question-form").hide(), Ke("stamped:reviews:loaded")
                    },
                    error: function(e) {}
                };
            f.length && (b.contentType = "application/json"), null != oe && oe.abort(), oe = P.ajax(b)
        }
    }

    function pe(e, t) {
        return e = e.replace(new RegExp(t + "(?!([^<]+)?<)", "gi"), '<span class="stamped-keyword-highlight">$&</span>')
    }

    function me(l, e) {
        if ((k = P(y)).length) {
            e = k.attr("data-product-id");
            var t = k.attr("data-product-sku"),
                a = k.attr("data-product-type"),
                s = k.attr("data-name"),
                p = k.attr("data-take-questions") || 5;
            if (!e) return;
            Ee("Loading Q&A"), P.ajax({
                type: "GET",
                url: q.SECURE_ENDPOINT + "/widget/questions",
                data: {
                    productId: e,
                    productSKU: t,
                    productType: a,
                    productTitle: s,
                    page: l || 1,
                    apiKey: L.StampedGlobalOptions.apiKey,
                    sId: L.StampedGlobalOptions.sId,
                    storeUrl: L.StampedGlobalOptions.storeUrl,
                    take: p || 5
                },
                success: function(e) {
                    if (1 == e.a && P(".stamped-questions").length) {
                        var t, a, s, i;
                        t = e.result, a = e.t, s = e.form, e.p, i = e.avatar;
                        P("#tab-questions").text();
                        P("#tab-questions").attr("data-count", a),
                            function(e) {
                                if (P(".stamped-questions").length && !P(".question-form-wrapper").length) {
                                    var t = P('<div class="question-form-wrapper">').html(e);
                                    P(".new-review-form").before(t)
                                }
                            }(s);
                        var r = P('<div class="stamped-questions">');
                        if (P(".stamped-questions").html(""), r.append(t), i) {
                            var d = P(".stamped-review #stamped-review-avatar", r),
                                n = P('<img src="' + i + '" width="100">');
                            d.html(n)
                        }
                        var o = P(".stamped-questions-placeholder");
                        o.length ? (P(".stamped-questions", o).html(""), P(".stamped-questions", o).replaceWith(r), P(".stamped-questions", o).length || (P(".stamped-questions").appendTo(o), P(".stamped-questions").replaceWith(r)), P(".stamped-questions", o).show(), P("#tab-questions").hide(), P(".question-form-wrapper").prependTo(o), P(".stamped-summary-actions-newquestion").prependTo(o)) : (P(".stamped-questions").replaceWith(r), l ? P(".stamped-questions").show() : P(".stamped-questions").hide()),
                            function(e, t, a) {
                                var s = 0 < e ? e / a < 1 ? 1 : Math.ceil(e / a) : 1;
                                if (1 == s) return;
                                var i = '<div class="stamped-pagination" id="stamped-pagination-question"><div><span id="stamped-pagination-prev" class="previous"><a onclick="StampedFn.pageQuestions(this)" data-product-id="" data-page="' + (t - 1) + '"><</a></span><span id="pages"></span><span id="stamped-pagination-next" class="next"><a onclick="StampedFn.pageQuestions(this)" data-product-id="" data-page="' + (t + 1) + '">></a></span></div></div>',
                                    r = P(".stamped-questions"),
                                    d = P(".stamped-questions-placeholder");
                                d.length && (r = P(".stamped-questions", d));
                                var n = P(".stamped-pagination", r);
                                n.length ? n.replaceWith(i) : r.append(i);
                                n = P(".stamped-pagination", r);
                                e = s, t = t;
                                var o = [];
                                if (o.push(1), e <= 7) {
                                    for (p = 2; p < e; p++) o.push(p);
                                    e == t && o.push(t)
                                }
                                if (8 <= e) {
                                    1 <= t - 2 && (t - 2 != 1 && o.push(t - 2), o.push(t - 1)), 1 != t && o.push(t);
                                    var l = t + 2;
                                    l <= e && (o.push(t + 1), l != e && o.push(t + 2))
                                }
                                1 == t || 1 == t ? P("#stamped-pagination-prev", n).hide() : P("#stamped-pagination-prev", n).show();
                                e == t || 1 == e ? P("#stamped-pagination-next", n).hide() : P("#stamped-pagination-next", n).show();
                                e != t && o.push(e);
                                for (var p = 0; p < o.length; p++) {
                                    o[p] == t ? P("#pages", n).append(' <span class="page active"><a style="cursor:pointer;" onclick="StampedFn.pageQuestions(this)" data-product-id="" data-page="' + o[p] + '">' + o[p] + "</a></span> ") : P("#pages", n).append(' <span class="page"><a style="cursor:pointer;" onclick="StampedFn.pageQuestions(this)" data-product-id="" data-page="' + o[p] + '">' + o[p] + "</a></span> ")
                                }
                            }(a, l || 1, p), o.length ? l && Se(".stamped-questions-placeholder") : l && Se(y), P(".stamped-review-reply-body", r).each(function() {
                                var e = P(this).html();
                                P(this).html(e.linkify())
                            }), Ke("stamped:questions:loaded")
                    }
                }
            })
        }
    }

    function ce(e, t) {
        P("#stamped-questions-placeholder, .stamped-questions-placeholder").length || (P(".stamped-tabs #tab-reviews").removeClass("active"), P(".stamped-tabs #tab-questions").removeClass("active"), "questions" == t ? P(".stamped-tabs #tab-questions").addClass("active") : "reviews" == t && P(".stamped-tabs #tab-reviews").addClass("active"), e && (P(e).addClass("active"), t = P(e).data("type")), "reviews" == t ? (P(".stamped-reviews").show(), P(".stamped-reviews-filter").show(), P(".stamped-questions").hide(), P("#stamped-sort-select").show()) : "questions" == t && (P(".stamped-reviews").hide(), P(".stamped-reviews-filter").hide(), P(".stamped-questions").show(), P("#stamped-sort-select").hide()), P(".new-review-form").hide(), P(".new-question-form").hide())
    }

    function ue(e) {
        var t = function(e, t) {
                for (var a = [], s = 0; s < t;) a[s++] = e;
                return a.join("")
            }("★", e.reviewRating),
            a = k.attr("data-image-url") || "",
            s = "https://stamped.io/facebookpost?caption=" + t + " " + encodeURIComponent(e.reviewTitle) + "&name=" + t + " " + encodeURIComponent(e.reviewTitle) + "&description=" + encodeURIComponent(e.reviewMessage) + "&link=" + encodeURIComponent(e.productUrl) + "&picture=" + encodeURIComponent(a.replace("%3F", "?")),
            i = "https://www.facebook.com/dialog/feed?app_id=222664514734026&display=popup&link=" + encodeURIComponent(s) + "&name=" + encodeURIComponent(e.reviewTitle) + "&redirect_uri=https://stamped.io/shares?productId=" + e.productId,
            r = "https://twitter.com/intent/tweet?text=" + t + " " + e.reviewMessage.substr(0, 140) + "&url=" + encodeURIComponent(e.productUrl),
            d = "https://plus.google.com/share?url=" + encodeURIComponent(e.productUrl),
            n = P(".stamped-thank-you .stamped-share-links");
        P(".facebook", n).attr("href", i), P(".twitter", n).attr("href", r), P(".google", n).attr("href", d)
    }
    var ge = [];

    function he(e, t) {
        var a = P(e),
            s = a.attr("data-element-id"),
            i = a.attr("data-widget-type"),
            r = (a.attr("data-widget-persist-data"), a.attr("data-review-id")),
            d = a.attr("data-review-ids") ? a.attr("data-review-ids").toString().split(",") : null,
            n = a.attr("data-product-id"),
            o = a.attr("data-product-ids") ? a.attr("data-product-ids").toString().split(",") : null,
            l = a.attr("data-product-category") || a.attr("data-product-type"),
            p = a.attr("data-product-brand"),
            m = a.attr("data-product-sku"),
            c = a.attr("data-limit-words"),
            u = a.attr("data-random"),
            g = a.attr("data-show-avatar"),
            h = a.attr("data-take"),
            v = a.attr("data-fill-empty"),
            f = a.attr("data-min-rating"),
            w = a.attr("data-min-length"),
            y = a.attr("data-rating"),
            b = a.attr("data-tags"),
            S = a.attr("data-tags-exclude"),
            k = a.attr("data-syndication") || !0,
            _ = a.data("with-photos"),
            C = a.data("sort-reviews"),
            I = a.data("widget-data"),
            T = a.data("widget-language"),
            O = a.data("instagram-gallery-id"),
            x = a.data("customer-email"),
            E = a.data("customer-first-name"),
            U = a.data("customer-id"),
            R = a.data("is-preview");
        return {
            type: i,
            reviewId: r,
            reviewIds: d,
            productId: n,
            productIds: o,
            productCategory: l,
            productBrand: p,
            productSKU: m,
            limitWords: c,
            random: u,
            showAvatar: g,
            isFillEmpty: v,
            apiKey: L.StampedGlobalOptions.apiKey,
            sId: L.StampedGlobalOptions.sId,
            storeUrl: L.StampedGlobalOptions.storeUrl,
            page: t,
            skip: h,
            minRating: f,
            minLength: w,
            rating: y,
            isWithPhotos: _,
            sortReviews: C,
            instagramGalleryId: O,
            dataType: I,
            widgetLanguage: T,
            tags: b,
            tagsExclude: S,
            isSyndication: k,
            elementId: s,
            customerEmail: x,
            customerFirstName: E,
            customerExternalId: U,
            isPreview: R
        }
    }

    function ve(n, e) {
        var t = q.SECURE_ENDPOINT + "/widget/reviews/batch";
        P.ajax({
            type: "POST",
            dataType: "json",
            contentType: "application/json",
            data: JSON.stringify({
                data: e
            }),
            xhrFields: {
                withCredentials: !0
            },
            url: t,
            success: function(e, t, a) {
                for (var s = e.length, i = 100, r = 0; r < s; r++)
                    if (e[r]) {
                        i += 50;
                        var d = e[r].elementId;
                        fe(P("rewards" == n ? '#stamped-rewards-widget[data-element-id="' + d + '"]' : '#stamped-reviews-widget[data-element-id="' + d + '"]'), e[r], e.translations, i)
                    }
            }
        })
    }

    function fe(o, l, e, t) {
        setTimeout(function() {
            if (l) {
                var e = l.template,
                    t = l.lang,
                    a = o.attr("data-widget-type"),
                    s = o.data("widget-persist-data") || !1;
                if (P(o).attr("data-lang", t || "en"), "instagram-feed" != a && "visual-gallery" != a && 1 != s && P(o).html(""), "single" == a) o.append(e), StampedWidgetSingleFn, StampedWidgetSingleFn.init(l.data, o, P);
                else if ("full-page" == a || "full-page-nps" == a) {
                    var i = o.attr("data-rich-snippet"),
                        r = "/" == location.pathname;
                    if (0 < l.total && "true" == i && !r) {
                        var d = {
                            "@context": "http://schema.org",
                            "@type": "Product",
                            name: l.shop,
                            aggregateRating: {
                                "@type": "AggregateRating",
                                ratingValue: l.rating,
                                reviewCount: l.total
                            }
                        };
                        (n = A.createElement("script")).type = "application/ld+json", n.innerHTML = JSON.stringify(d), A.getElementsByTagName("head")[0].appendChild(n)
                    }
                    o.append(e), StampedWidgetFullPageFn, StampedWidgetFullPageFn.init(l, o, P)
                } else if ("full-page-multiple" == a) o.append(e), StampedWidgetFullPageMultipleFn, StampedWidgetFullPageMultipleFn.init(l, o, P);
                else if ("reviews-highlight" == a) o.append(e), StampedWidgetReviewsHighlightFn, StampedWidgetReviewsHighlightFn.init(l, o, P);
                else if ("people-highlight" == a) o.append(e), StampedWidgetPeopleHighlightFn, StampedWidgetPeopleHighlightFn.init(l, o, P);
                else if ("drawer" == a) o.append(e), StampedWidgetDrawerFn, StampedWidgetDrawerFn.init(l, o, P);
                else if ("carousel" == a) o.append(e), StampedCarouselFn, StampedCarouselFn.init(l, o, P);
                else if ("carousel-nps" == a) o.append(e), StampedCarouselNPSFn, StampedCarouselNPSFn.init(l, o, P);
                else if ("carousel-photos" == a) o.append(e), StampedCarouselPhotosFn, StampedCarouselPhotosFn.init(l.data, o, P);
                else if ("site-badge" == a) {
                    i = o.attr("data-rich-snippet"), r = "/" == location.pathname;
                    if (0 < l.total && "true" == i && !r) {
                        var n;
                        d = {
                            "@context": "http://schema.org",
                            "@type": "Product",
                            name: l.shop,
                            aggregateRating: {
                                "@type": "AggregateRating",
                                ratingValue: l.rating,
                                reviewCount: l.total
                            }
                        };
                        (n = A.createElement("script")).type = "application/ld+json", n.innerHTML = JSON.stringify(d), A.getElementsByTagName("head")[0].appendChild(n)
                    }
                    o.append(e), StampedSiteBadgeFn, StampedSiteBadgeFn.init(l, o, P)
                } else "top-rated" == a ? (o.append(e), StampedTopRatedFn, StampedTopRatedFn.init(l, o, P)) : "wall-photos" == a ? (o.append(e), StampedWallPhotosFn, StampedWallPhotosFn.init(l, o, P)) : "checkout-comments" == a ? (o.append(e), StampedCheckoutCommentsFn, StampedCheckoutCommentsFn.init(l, o, P)) : "instagram-feed" == a ? (L.stampedInstagramDataArr && !P(o).is(":empty") || o.append(e), StampedInstagramFeedFn, StampedInstagramFeedFn.init(l, o, P)) : "visual-gallery" == a ? (L.stampedVisualGalleryDataArr || o.append(e), StampedVisualGalleryFeedFn, StampedVisualGalleryFeedFn.init(l, o, P)) : "facebook-messenger-optin" == a ? (StampedFacebookMessengerOptinFn, StampedFacebookMessengerOptinFn.init(l, o, P)) : "nps-submission-form" == a ? (o.append(e), StampedNPSSubmissionForm, StampedNPSSubmissionForm.init(l, o, P)) : "rewards-summary" == a ? (o.append(e), StampedRewardsSummary, StampedRewardsSummary.init(l, o, P)) : "rewards-how-it-works" == a ? (o.append(e), StampedRewardsHowItWorks, StampedRewardsHowItWorks.init(l, o, P)) : "rewards-referral-modal" == a ? (o.append(e), StampedRewardsReferralModal, StampedRewardsReferralModal.init(l, o, P)) : "rewards-referral-claim-modal" == a ? (o.append(e), StampedRewardsReferralClaimModal, StampedRewardsReferralClaimModal.init(l, o, P)) : "rewards-earnings" == a ? (o.append(e), StampedRewardsEarnings, StampedRewardsEarnings.init(l, o, P)) : "rewards-spendings" == a ? (o.append(e), StampedRewardsSpendings, StampedRewardsSpendings.init(l, o, P)) : "rewards-referral" == a ? (o.append(e), StampedRewardsReferral, StampedRewardsReferral.init(l, o, P)) : "rewards-redeem-variable-slider" == a ? (o.append(e), StampedRewardsRedeemVariableSlider, StampedRewardsRedeemVariableSlider.init(l, o, P)) : "rewards-redeem-select-options" == a ? (o.append(e), StampedRewardsRedeemSelectOptions, StampedRewardsRedeemSelectOptions.init(l, o, P)) : "widget-development" == a && (StampedWidgetDevFn, StampedWidgetDevFn.init(l, o, P));
                Ke("stamped:reviews:widget:loaded")
            }
        }, t)
    }

    function we(e, t, a) {
        if (a) {
            var s = new Date;
            s.setTime(s.getTime() + 24 * a * 60 * 60 * 1e3);
            var i = "; expires=" + s.toGMTString()
        } else i = "";
        A.cookie = e + "=" + t + i + "; path=/; SameSite=None; Secure"
    }

    function ye(e) {
        for (var t = e + "=", a = A.cookie.split(";"), s = 0; s < a.length; s++) {
            for (var i = a[s];
                " " == i.charAt(0);) i = i.substring(1, i.length);
            if (0 == i.indexOf(t)) return i.substring(t.length, i.length)
        }
        return null
    }

    function be(e) {
        for (var t in e) null !== e[t] && "" !== e[t] && void 0 !== e[t] || delete e[t];
        return e
    }

    function Se(e) {
        if (P(e).length) {
            var t = P(y).attr("data-animation");
            if ("false" !== t) {
                var a = P(e),
                    s = P("html, body"),
                    i = P(y).attr("data-offset") || 1;
                I() && (i = P(y).attr("data-offset-mobile") || 1), s.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function() {
                    s.stop()
                }), s.animate({
                    scrollTop: a.offset().top - i
                }, t || 1e3, function() {
                    s.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove")
                })
            }
        }
    }

    function ke(e) {
        if ("review" == e) {
            ce(null, "reviews");
            var t = P(".new-review-form");
            (a = P(".new-question-form")).slideUp(), a.removeClass("stamped-visible"), t.hasClass("stamped-visible") ? (t.slideUp(), t.removeClass("stamped-visible")) : (t.slideDown(), t.addClass("stamped-visible"))
        } else if ("question" == e) {
            ce(null, "questions");
            var a;
            t = P(".new-question-form");
            (a = P(".new-review-form")).slideUp(), a.removeClass("stamped-visible"), t.hasClass("stamped-visible") ? (t.slideUp(), t.removeClass("stamped-visible")) : (t.slideDown(), t.addClass("stamped-visible"))
        }
    }

    function _e(e, t, a, s) {
        P(y).length && (ue(e), P(".stamped-user-review", k).hide(), P(".stamped-thank-you", k).show(), t.reviewRating < 3 ? (P(".stamped-thank-you p", k).hide(), P(".stamped-thank-you .stamped-share-links", k).hide()) : (P(".stamped-thank-you p", k).show(), P(".stamped-thank-you .stamped-share-links", k).show()), P(".new-review-form", k).hide(), P(".edit-review-form", k).hide(), P(".stamped-summary-actions-newreview").hide(), P("#stamped-button-submit", k).removeAttr("disabled"), s && P("#stamped-button-submit", k).val(s), Se(y), function(e, t, a) {
            if (null != ye("stamped-user-reviews")) {
                for (var s = JSON.parse(ye("stamped-user-reviews")), i = !1, r = 0; r < s.length; r++)
                    if (s[r].pid == e) {
                        i = !0, s[r];
                        break
                    }! i && e && t && 1 == a && (10 <= s.length && s.splice(0, 1), s.push({
                    pid: e,
                    v: t
                }), we("stamped-user-reviews", JSON.stringify(s), 1))
            } else if (e && t && 1 == a) {
                var d = [{
                    pid: e,
                    v: t
                }];
                we("stamped-user-reviews", JSON.stringify(d), 1)
            }
        }(a.productId, t.userReference, !0)), Ke("stamped:reviews:submitted")
    }

    function Ce(e, t, a) {
        P || jQuery && (P = jQuery), a && P(a).closest(y).length && (k = P(a).closest(y));
        k.attr("data-product-id");
        var s, i = P(".stamped-summary-ratings.selected .summary-rating-bar.selected", k).attr("data-rating");
        i && (t = i), P(".stamped-sort-select", k).length && (s = P(".stamped-sort-select", k).val()), le(e, s, t)
    }

    function Ie() {
        var e;
        P("select.stamped-filter-select").each(function() {
            P(this).val("")
        }), P(".stamped-summary-keywords-list li").removeClass("selected"), P(k).removeAttr("data-keyword"), P(".stamped-summary-actions-clear").hide(), P(".stamped-reviews", k).removeAttr("data-filtered"), P(".stamped-sort-select").length && (e = P(".stamped-sort-select").val()), _ = {}, P(".stamped-reviews-search-input").val(""), P(".stamped-reviews-search-clear").hide(), P(k).removeAttr("data-search"), re(), le(1, e, null, !0)
    }
    String.linkify || (String.prototype.linkify = function() {
        return this.replace(/\b(?:https?|ftp):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim, '<a href="$&">$&</a>').replace(/(^|[^\/])(www\.[\S]+(\b|$))/gim, '$1<a href="http://$2">$2</a>').replace(/[\w.]+@[a-zA-Z_-]+?(?:\.[a-zA-Z]{2,6})+/gim, '<a href="mailto:$&">$&</a>')
    });
    var Te = !1,
        Oe = null;

    function xe(e, t) {
        t = t || L.location.href, e = e.replace(/[\[\]]/g, "\\$&");
        var a = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(t);
        return a ? a[2] ? decodeURIComponent(a[2].replace(/\+/g, " ")) : "" : null
    }

    function Ee(e, t) {
        var a = "true" == xe("stamped_debug") || 1 == L.stamped_debug,
            s = L.stamped_debug_level || xe("stamped_debug_level");
        a && (t || console.log("[Stamped.io]", e), t && s && console.log("[Stamped.io level" + s + "]", e))
    }

    function Ue(e, t) {
        (s = A.createElement("script")).type = "text/javascript", s.charset = "UTF-8", s.src = e;
        var a = A.getElementsByTagName("script")[0];
        a.parentNode.insertBefore(s, a), s.onload = s.onreadystatechange = t
    }

    function Re(e, t) {
        return "undefined" != typeof Storage && (localStorage.setItem(e, JSON.stringify(t)), 1)
    }

    function Fe(t) {
        if ("undefined" == typeof Storage) return !1;
        var a;
        try {
            a = JSON.parse(localStorage.getItem(t)) || null
        } catch (e) {
            a = localStorage.getItem(t)
        }
        return a
    }

    function je(e, t) {
        var a = "stamped_app_key",
            s = Fe(a);
        if (s && s.apiKey) Ee(s), Ke("stamped:init:getAppKey", {
            detail: s
        }), Ne(s);
        else {
            var i;
            (i = new XMLHttpRequest).onreadystatechange = function() {
                if (4 === i.readyState && 200 === i.status) {
                    var e = JSON.parse(i.responseText);
                    if (e && e.apiKey && (Re(a, e), Ke("stamped:init:getAppKey", {
                            detail: e
                        }), !0 !== e.skip)) {
                        appKey = e.apiKey;
                        var t = {
                            apiKey: appKey
                        };
                        "undefined" != typeof Shopify ? t.storeUrl = Shopify.shop : t.sId = e.sId, Ne(t)
                    }
                }
            };
            var r = "";
            "shopify" == e ? r = "shopShopifyDomain=" + t : "bigcommerce" == e && (r = "storeHash=" + t), i.open("GET", "//stamped.io/api/getappkey?" + r, !0), i.send()
        }
    }

    function Ne(e) {
        if (1 == L.isInitializedStamped) return Ee("Already initalized"), StampedFn.loadWidget(!0), void StampedFn.loadDisplayWidgets();
        if (L.isInitializedStamped = !0, e && (L.StampedGlobalOptions = e), L.StampedGlobalOptions && L.StampedGlobalOptions.apiKey) {
            var t = "true" == xe("stamped_force_jquery");
            "undefined" == typeof jQuery || 1 == t ? Ue("https://ajax.googleapis.com/ajax/libs/jquery/1.11.0/jquery.min.js", function() {
                P = jQuery.noConflict(!0), E(), L.isInitializedStamped = !0
            }) : (E(0, jQuery), L.isInitializedStamped = !0)
        }
    }
    var Ge = A.getElementById("stamped-script-widget"),
        Le = "";
    (Ge = Ge || A.getElementById("stamped-script-init")) && (Le = Ge.src);
    var Ae = !1;
    if ((0 < Le.indexOf("skipCss=true") || 1 == q.exclude_main_css) && (Ae = !0), Ae || function(e) {
            for (var t = A.styleSheets, a = 0, s = t.length; a < s; a++)
                if (t[a] && t[a].href && -1 < t[a].href.indexOf(e)) return;
            var i = A.createElement("link");
            i.rel = "stylesheet", i.href = e, i.type = "text/css";
            var r = A.getElementsByTagName("link")[0];
            if (r) r.parentNode.insertBefore(i, r);
            else {
                var d = A.getElementsByTagName("head")[0];
                i.setAttribute("async", ""), d.appendChild(i)
            }
        }("//cdn1.stamped.io/files/widget.min.css"), "undefined" != typeof Shopify) {
        var Pe = !1;
        if (Shopify.shop) {
            if (null != Ge) {
                -1 < Le.indexOf("skip=true") && (Pe = !0);
                var qe = Ge.getAttribute("data-api-key");
                !qe && -1 < Le.indexOf("apiKey") && (qe = xe("apiKey", Le)), qe && (Pe = !0, Ne({
                    apiKey: qe,
                    storeUrl: Shopify.shop
                }))
            }
            Pe || je("shopify", Shopify.shop)
        }
        if (Shopify.Checkout && "undefined" == typeof StampedShopifyCheckout) {
            if ("function" == typeof L.StampedShopifyCheckout) return !1;
            Ue("//cdn1.stamped.io/files/shopify-checkout.min.js", function() {
                Ke("stamped:script-shopify-checkout:loaded")
            })
        }
    }
    if (null != Ge) {
        var De = Ge.getAttribute("data-store-hash");
        De && je("bigcommerce", De)
    }

    function Ke(e, t) {
        var a;
        L.CustomEvent ? a = new CustomEvent(e, t) : (a = A.createEvent("CustomEvent")).initCustomEvent(e, !0, !0, t);
        try {
            A.dispatchEvent(a)
        } catch (e) {}
    }
    return {
        init: Ne,
        initRewards: j,
        reloadUGC: F,
        toggleForm: ke,
        setRating: function(e) {
            var t, a, s, i, r;
            t = P(e).parents(".new-review-form"), s = P(e).attr("data-value"), a = P(e).parent(), t.find("input[name='reviewRating']").val(s), i = s, (r = a).find("a:lt(" + i + ")").removeClass("fa-star-o").addClass("fa-star-checked"), r.find("a:gt(" + (i - 1) + ")").removeClass("fa-star-checked").addClass("fa-star-o")
        },
        submitForm: function(e) {
            var t, a, s = k.data("label-submitting"),
                i = P(".new-review-form .stamped-button-primary", k).val();
            if ((a = function(e) {
                    var t = {};
                    P(e).hasClass("new-review-form") || (e = P(e).parents(".new-review-form"));
                    var a = P("input,textarea,select,radio", e).serializeArray();
                    return P.each(a, function() {
                        void 0 !== t[this.name] ? (t[this.name].push || (t[this.name] = [t[this.name]]), t[this.name].push(this.value || "")) : t[this.name] = this.value || ""
                    }), t
                }(e)).reviewRating && a.author) {
                var r = {
                    productName: k.attr("data-name"),
                    productId: k.attr("data-product-id"),
                    productSKU: k.attr("data-product-sku"),
                    productDescription: k.attr("data-description"),
                    productImageUrl: k.attr("data-image-url"),
                    productUrl: k.attr("data-url"),
                    reviewSource: "widget",
                    userReference: k.attr("data-user-reference")
                };
                a = P.extend(a, r), t = a, a = (a = P.param(a)).replace(/%0D%0A/g, "%0A"), P.ajax({
                    url: q.SECURE_ENDPOINT + "/reviews2?" + P.param(be({
                        apiKey: L.StampedGlobalOptions.apiKey,
                        sId: L.StampedGlobalOptions.sId,
                        storeUrl: L.StampedGlobalOptions.storeUrl,
                        photos: f.join()
                    })),
                    type: "POST",
                    data: a,
                    beforeSend: function(e) {
                        P("#stamped-button-submit", k).attr("disabled", "disabled"), s && P("#stamped-button-submit", k).val(s)
                    },
                    error: function(e) {
                        Ke("stamped:reviews:submitError"), 1 == q.is_ignore_submit_error ? _e(t, e, r, i) : (P("#stamped-button-submit", k).removeAttr("disabled"), i && P("#stamped-button-submit", k).val(i))
                    },
                    success: function(e) {
                        _e(t, e, r, i)
                    }
                })
            }
        },
        submitQuestionForm: function() {
            var t = P("#new-question-form"),
                e = P(y);
            if (t.length && e.length) {
                var a = e.data("name"),
                    s = e.data("description"),
                    i = e.data("product-sku"),
                    r = e.data("url"),
                    d = e.data("image-url"),
                    n = t.serializeArray();
                n.push({
                    name: "productName",
                    value: a
                }), n.push({
                    name: "productDescription",
                    value: s
                }), n.push({
                    name: "productSKU",
                    value: i
                }), n.push({
                    name: "productUrl",
                    value: r
                }), n.push({
                    name: "productImageUrl",
                    value: d
                }), n.push({
                    name: "apiKey",
                    value: L.StampedGlobalOptions.apiKey
                }), n.push({
                    name: "sId",
                    value: L.StampedGlobalOptions.sId
                }), n.push({
                    name: "storeUrl",
                    value: L.StampedGlobalOptions.storeUrl
                }), P('input[type="submit"]', t).attr("disabled", "disabled"), P.ajax({
                    type: "POST",
                    url: "//stamped.io/api/questions",
                    data: P.param(n),
                    crossDomain: !0,
                    success: function(e) {
                        P("#new-question-form").hide(), P(".stamped-form-message-success").show(), P("#new-question-form")[0].reset(), P('input[type="submit"]', t).removeAttr("disabled")
                    }
                })
            }
        },
        toggleFormEdit: function() {
            P(".edit-review-form", k).toggle()
        },
        pageQuestions: function(e) {
            var t = k.attr("data-product-id");
            me(P(e).data("page"), t)
        },
        pageReviews: Ce,
        sortReviews: function(e) {
            k.attr("data-product-id"), e.value && le(1, e.value, null, !0)
        },
        filterReviews: function() {
            _ = {};
            var e, a = 1;
            P("select.stamped-filter-select").each(function() {
                var e = P("option:first-child", this).text(),
                    t = this.value;
                _["qt" + a] = e, _["qv" + a] = t, a++
            }), P(".stamped-summary-actions-clear").show(), P(".stamped-reviews", k).attr("data-filtered", "true"), P(".stamped-sort-select").length && (e = P(".stamped-sort-select").val()), le(1, e, null, !0)
        },
        filterClear: Ie,
        pageWidget: function(e) {
            var s, t, a, i, r = P(e).data("page"),
                d = P(e).closest("#stamped-reviews-widget");
            d.attr("data-page", r), s = d, t = r, a = q.SECURE_ENDPOINT + "/widget/reviews", i = he(s, t), P.ajax({
                type: "GET",
                url: a + "?" + P.param(be(i)),
                dataType: "json",
                success: function(e, t, a) {
                    fe(s, e)
                }
            })
        },
        loadBadges: ee,
        loadWidget: Y,
        loadDisplayWidgets: te,
        voteReview: function(e, t, a) {
            var s = P(e);
            s.parent().fadeTo("slow", .3), s.addClass("disable-link"), P.ajax({
                type: "POST",
                url: q.SECURE_ENDPOINT + "/reviews/vote",
                data: {
                    reviewId: t,
                    vote: a,
                    apiKey: L.StampedGlobalOptions.apiKey,
                    sId: L.StampedGlobalOptions.sId,
                    storeUrl: L.StampedGlobalOptions.storeUrl
                },
                success: function(e) {
                    if (1 === e || -1 === e) {
                        var t = s.attr("data-count"),
                            a = parseInt(t);
                        s.attr("data-count", a + e)
                    }
                    s.parent().fadeTo("slow", 1), s.removeClass("disable-link")
                }
            })
        },
        openUGCModal: function(I, e, t, a, s, T, O, x) {
            var E, U;
            1 !== a && a || (I = function(e, t) {
                var a = [];
                for (i = 0; i < e.length; i++) {
                    var s = e[i];
                    if (1 != t || s.reviewUserPhotos || s.reviewUserVideos) {
                        var r = {
                            photos: [],
                            videos: [],
                            name: s.author,
                            via: "Photos",
                            title: s.reviewTitle,
                            body: s.reviewMessage,
                            date: s.reviewDate,
                            reply: s.reviewReply,
                            dateReplied: s.dateReplied,
                            dateFull: s.dateCreated,
                            verifiedType: s.reviewVerifiedType,
                            rating: s.reviewRating,
                            products: [{
                                url: s.productUrl,
                                title: s.productName,
                                imageUrl: s.productImageLargeUrl,
                                imageLargeUrl: s.productImageLargeUrl
                            }],
                            review_id: s.id,
                            votes: {
                                up: s.reviewVotesUp,
                                down: s.reviewVotesDown
                            },
                            options: []
                        };
                        if (s.reviewUserPhotos || s.reviewUserVideos) {
                            if (s.reviewUserVideos) {
                                var d = s.reviewUserVideos.split(",");
                                for (ii = 0; ii < d.length; ii++) {
                                    var n = "//cdn.stamped.io/uploads/videos/" + d[ii],
                                        o = "//cdn.stamped.io/uploads/videos/" + d[ii] + ".jpg";
                                    n.indexOf(".mp4") < 0 && (n += ".mp4"), 0 <= n.indexOf("nothumb") && (o = ""), r.photos.push({
                                        videoUrl: n,
                                        imageThumbnailUrl: o
                                    })
                                }
                            }
                            if (s.reviewUserPhotos) {
                                var l = s.reviewUserPhotos.split(",");
                                for (ii = 0; ii < l.length; ii++) r.photos.push({
                                    imageUrl: "//cdn.stamped.io/uploads/photos/" + l[ii],
                                    imageThumbnailUrl: "//cdn.stamped.io/uploads/photos/thumb/" + l[ii]
                                })
                            }
                        } else r.photos.push({
                            imageUrl: s.productImageLargeUrl,
                            imageThumbnailUrl: s.productImageUrl
                        });
                        if (s.reviewOptionsList && s.reviewOptionsList.length)
                            for (ii = 0; ii < s.reviewOptionsList.length; ii++) r.options.push({
                                message: s.reviewOptionsList[ii].message,
                                value: s.reviewOptionsList[ii].value
                            });
                        a.push(r)
                    }
                }
                return a
            }(I, s)), null != I || I.length || g(e, T);
            var r, d = '<div class="stamped-ugc-modal" data-lang="' + (O = O || "en") + '"> <div class="stamped-ugc-modal-wrapper"><a href="javascript:void(0)" title="Close" aria-label="Close" role="button" class="stamped-modal-close show-mobile" style="display:none;" tabindex="0">X</a> <div class="stamped-ugc-modal-nav stamped-ugc-modal-nav-previous" data-direction="left" tabindex="0" aria-label="Previous Photo"> <i class="stamped-fa stamped-fa-angle-left"></i> </div> <div class="stamped-ugc-modal-image-wrapper"> <div class="stamped-ugc-modal-image"></div> <ul></ul> </div> <div class="stamped-ugc-modal-content"> <a href="javascript:void(0)" title="Close" aria-label="Close" role="button" class="stamped-modal-close" tabindex="0">X</a> <div class="stamped-ugc-modal-content-wrapper"> <div class="stamped-ugc-modal-user"> <div class="stamped-ugc-modal-user-source"></div><div class="stamped-ugc-modal-user-username"></div> </div> <div class="stamped-ugc-modal-caption"></div><div class="stamped-ugc-modal-votes"></div> <div class="stamped-ugc-modal-tags"> <a aria-label="Link to Product" {0} target="_top"> <div class="stamped-ugc-modal-tags-product-image-wrapper"><img {1} class="stamped-ugc-modal-tags-product-image" onerror=\'this.style.display = "none"\' alt="Product Image" /></div> <div class="stamped-ugc-modal-tags-product-title">{2}</div> <div class="stamped-ugc-modal-tags-btn"></div> </a> </div> </div> </div> <div class="stamped-ugc-modal-nav stamped-ugc-modal-nav-next" data-direction="right" tabindex="0" aria-label="Next Photo"> <i class="stamped-fa stamped-fa-angle-right"></i> </div> <div class="stamped-ugc-modal-list-photos"><ul></ul></div> </div> </div>',
                R = (P(t).attr("data-hover-text"), P(t).attr("data-shop-button-text"), P(t).attr("data-url-param") || ""),
                F = P(t).attr("data-url-store") || L.stamped_global_url_store || "";
            P(t).attr("data-cropped"), P(t).attr("data-page"), P(t).attr("data-take"), P("#stamped-ugc-modal").length || ((E = P(d)).attr("data-modal-type", a), P(E).appendTo(A.body));
            var n = "",
                o = I.length;
            U = U || P(".stamped-ugc-modal-tags:first", E).html();
            for (var l = I ? I.length : 0, j = 0; j < o; j++) {
                var p = I[j],
                    m = p.imageUrl;
                m && (n += templateBlock.formatStringStamped(l, m), l++), p.photos.length && p.photos[0].imageUrl && (ge[j] = new Image, ge[j].src = p.photos[0].imageUrl)
            }
            if (P(".stamped-ugc-media-block-template", t).append(n), P(t).keydown(function(e) {
                    if (37 === e.keyCode) h("left");
                    else {
                        if (39 !== e.keyCode) return;
                        h("right")
                    }
                }), !r) {
                P(A).on("click keypress", ".stamped-modal-close, .stamped-ugc-modal.open", function(e) {
                    if (!0 === D(e)) {
                        if (e.target != this) return;
                        E.remove(), P("body").removeClass("stamped-modal-open")
                    }
                }), E.on("click keypress", ".stamped-ugc-modal-nav-previous, .stamped-ugc-modal-nav-next", function(e) {
                    if (!0 === D(e)) {
                        var t = P(this).attr("data-direction");
                        h(t)
                    }
                });
                A.addEventListener("touchstart", function(e) {
                    c = e.touches[0].clientX, u = e.touches[0].clientY
                }, !1), A.addEventListener("touchmove", function(e) {
                    if (!c || !u) return;
                    var t = e.touches[0].clientX,
                        a = e.touches[0].clientY,
                        s = c - t,
                        i = u - a;
                    Math.abs(s) > Math.abs(i) && h(0 < s ? "right" : "left");
                    u = c = null
                }, !1);
                var c = null,
                    u = null
            }

            function N() {
                var e = Number(P(this).text()) + 1,
                    t = P(this).data("image-url");
                P(".stamped-ugc-modal-image-wrapper ul li").removeClass("active"), P(".stamped-ugc-modal-image-wrapper ul li:nth-child(" + e + ")").addClass("active"), "image" == q.modal_ugc_gallery ? P(".stamped-ugc-modal-image", E).append('<img src="' + t + '" alt="Customer Photo" />') : P(".stamped-ugc-modal-image", E).css("background-image", "url(" + t + ")"), Ke("stamped:ugcmodal:paged")
            }

            function G() {
                var e = P(this).data("index-review"),
                    t = P(this).data("index-photo");
                P(".stamped-ugc-modal-list-photos ul li").removeClass("active"), P(".stamped-ugc-modal-list-photos ul li[data-index-review=" + e + "][data-index-photo=" + t + "]").addClass("active"), g(e, t), Ke("stamped:ugcmodal:paged")
            }
            r = !0;
            var g = function(e, t) {
                    var a = I[e];
                    if (null != a && null != a.photos) {
                        if (null !== t ? (T = t) > a.photos.length - 1 && (T = 0) : T ? T > a.photos.length - 1 && (T = 0) : T = 0, !P(".stamped-ugc-modal-list-photos ul li", E).length)
                            for (var s = 0; s < I.length; s++)
                                for (var i = 0; i < I[s].photos.length; i++) {
                                    var r = e == s && t == i ? "active" : "",
                                        d = (I[s].photos[i].imageUrl, I[s].photos[i].imageThumbnailUrl),
                                        n = A.createElement("li");
                                    n.className = r, n.innerHTML = "";
                                    var o = A.createAttribute("data-index-review");
                                    o.value = s, n.setAttributeNode(o), (m = A.createAttribute("data-index-photo")).value = i, n.setAttributeNode(m), n.style.background = "url(" + d + ")", P(".stamped-ugc-modal-list-photos ul", E).append(n), n.onclick = G
                                }
                        if (null != a.photos[T]) {
                            var l = a.photos[T].imageUrl,
                                p = a.photos[T].videoUrl;
                            l ? "image" == q.modal_ugc_image_viewer ? P(".stamped-ugc-modal-image", E).html('<img src="' + l + '" alt="Customer Photo" />') : P(".stamped-ugc-modal-image", E).css("background-image", "url(" + l + ")") : p && P(".stamped-ugc-modal-image", E).fadeOut("", function() {
                                P(".stamped-ugc-modal-image", E).css("background-image", 'url("")'), P(".stamped-ugc-modal-image", E).html('<video class="stamped-ugc-modal-video" src="' + p + '" width="100%" controls autoplay style="width: 100%; height: 100%;max-height: 600px; position: absolute;" />'), P(this).fadeIn()
                            })
                        }
                        for (P(".stamped-ugc-modal-image-wrapper ul", E).html(""), ii = 0; ii < a.photos.length; ii++) {
                            var m, c = ii === T ? "active" : "",
                                u = A.createElement("li");
                            u.className = c, u.innerHTML = ii, (m = A.createAttribute("data-image-url")).value = a.photos[ii].imageUrl, u.setAttributeNode(m), P(".stamped-ugc-modal-image-wrapper ul", E).append(u), u.onclick = N
                        }
                        P(".stamped-ugc-modal-user-source").text(a.via), P(".stamped-ugc-modal-user-username", E).text(a.name);
                        var g = "Verified Buyer",
                            h = "Shop Now";
                        x && "en" != O && (g = x.label_verified_buyer || g, h = x.label_shop_now || h), P(".stamped-ugc-modal-user-username", E).append('<span class="stamped-verified-badge">' + g + "</span>"), P(".stamped-ugc-modal-tags-btn", E).append("<span>" + h + "</span>");
                        var v = "";
                        if (a.rating) {
                            for (var f = 0; f < a.rating; f++) v += '<i class="stamped-fa stamped-fa-star"></i>';
                            for (f = 0; f < 5 - a.rating; f++) v += '<i class="stamped-fa stamped-fa-star-o"></i>'
                        }
                        var w, y = "";
                        if (a.options && a.options.length) {
                            for (y += '<ul class="">', j = 0; j < a.options.length; j++) {
                                var b = a.options[j].message,
                                    S = a.options[j].value;
                                y += '<li data-value="' + b.toString().toLowerCase().trim().replace(/\s+/g, "-").replace(/[^\w\-]+/g, "").replace(/\-\-+/g, "-").replace(/^-+/, "").replace(/-+$/, "") + '"><span class="stamped-ugc-modal-options-message">' + b + '</span> <span class="stamped-ugc-modal-options-value">' + S + "</span></li>"
                            }
                            y += "</ul>"
                        }
                        a.reply || (a.reply = ""), w = a.dateFull ? new Date(a.dateFull) : new Date(a.date);
                        var k = (new timeagoStamped).formatDateString(w);
                        for ("en" != O && (k = a.date), P(".stamped-ugc-modal-caption", E).html('<div class="stamped-ugc-modal-date" data-date="' + a.date + '">' + k + '</div><div class="stamped-ugc-modal-caption-rating">' + v + '</div><div class="stamped-ugc-modal-caption-options">' + y + '</div><div class="stamped-ugc-modal-caption-title">' + (a.title || "") + '</div> <div class="stamped-ugc-modal-caption-body">' + a.body + '</div> <div class="stamped-ugc-modal-caption-reply">' + a.reply + "</div>"), P(".stamped-ugc-modal-votes", E).html('<span class="stamped-ugc-modal-vote-up" data-count="' + a.votes.up + '" onclick="StampedFn.voteReview(this, ' + a.review_id + ',1)"><i class="stamped-fa stamped-fa-thumbs-up"></i></span><span class="stamped-ugc-modal-vote-down" data-count="' + a.votes.down + '" onclick="StampedFn.voteReview(this, ' + a.review_id + ',1)"><i class="stamped-fa stamped-fa-thumbs-down"></i></span>'), P(".stamped-ugc-modal-tags", E).html(""), j = 0; j < a.products.length; j++) {
                            var _ = a.products[j];
                            _.title = _.title ? _.title : "", F ? (_.url = _.url.replace("?storeUrl=https://", ""), _.url = _.url + "?storeUrl=" + F) : R && (_.url = _.url + "?param=" + R);
                            var C = _.imageUrl || _.imageLargeUrl;
                            _.imageUrl ? P(".stamped-ugc-modal-tags", E).append(U.formatStringStamped('href="' + _.url + '"', 'src="' + C + '"', _.title)) : P(".stamped-ugc-modal-tags", E).append(U.formatStringStamped('href="' + _.url + '"', "", _.title))
                        }
                        E.hasClass("open") || (E.addClass("open"), P("body").addClass("stamped-modal-open"), Ke("stamped:ugcmodal:open")), E.attr("data-review-index", e), E.attr("data-photo-index", T)
                    }
                },
                h = function(e) {
                    if (E.hasClass("open")) {
                        E.attr("data-review-index"), E.attr("data-photo-index");
                        if ("left" == e) P(".stamped-ugc-modal-list-photos ul li.active").prev().click();
                        else {
                            if ("right" != e) return;
                            var t = P(".stamped-ugc-modal-list-photos ul li.active").next();
                            P(t.click()), t.length || "instagram" == E.attr("data-modal-type") && Ke("stamped:ugcmodal:last")
                        }
                    }
                };
            null != I && I.length && g(e, T)
        },
        openUGCPhoto: function(r, e, d, t) {
            if (Te) {
                for (var a = null, s = 0; s < w.length; s++) w[s].id == r && (a = s);
                null != a && StampedFn.openUGCModal(w, a, P(y), null, null, d, Oe), Te = !1
            } else {
                Te = !0;
                var i = q.SECURE_ENDPOINT + "/widget/reviews",
                    n = P(k).attr("data-product-sku") || "",
                    o = "",
                    l = "",
                    p = [];
                !0 === t ? (e = P(k).attr("data-product-id") || "", o = P(k).attr("data-name") || "", l = P(k).attr("data-product-type") || "") : P(".stamped-reviews .stamped-review", k).each(function() {
                    var e = P(this).attr("id");
                    (e = e.replace("stamped-review-", "")) && p.push(e)
                }), P.ajax({
                    type: "GET",
                    url: i + "?" + P.param(be({
                        type: "widget-carousel-photos",
                        reviewIds: p,
                        productId: e,
                        productSKU: n,
                        productType: l,
                        productTitle: o,
                        random: !1,
                        isFillEmpty: !1,
                        page: 1,
                        skip: 100,
                        minRating: 1,
                        isWithPhotos: !0,
                        apiKey: L.StampedGlobalOptions.apiKey,
                        sId: L.StampedGlobalOptions.sId,
                        storeUrl: L.StampedGlobalOptions.storeUrl
                    })),
                    dataType: "json",
                    success: function(e, t, a) {
                        w = e.data;
                        for (var s = null, i = 0; i < w.length; i++) w[i].id == r && (s = i);
                        null != s && (Oe = e.lang, StampedFn.openUGCModal(w, s, P(y), null, null, d, Oe, e.translations)), Te = !1, 0
                    }
                })
            }
            return !1
        },
        initOptions: L.StampedGlobalOptions,
        loadSurveyOptin: function(e) {
            var t, a = setInterval(function() {
                void 0 !== L.StampedGlobalOptions && (null !== e && e.orderId && P.ajax({
                    type: "GET",
                    url: "//stamped.io/api/plugin/facebookmessenger?" + P.param(be({
                        apiKey: L.StampedGlobalOptions.apiKey,
                        sId: L.StampedGlobalOptions.sId,
                        storeUrl: L.StampedGlobalOptions.storeUrl,
                        orderId: e.orderId,
                        customerEmail: e.customerEmail
                    })),
                    success: function(e) {
                        P("body").append(e.html);
                        var t = P("#stamped-facebook-optin .fb-send-to-messenger")[0].outerHTML,
                            a = A.createElement("iframe");
                        a.height = "100", a.width = "100%";
                        var s = "<!DOCTYPE html> <html> <head> <meta charset='utf-8' /> <title></title> </head> <script> var fbPageId, fbUserRef; window.fbAsyncInit = function() { FB.init({ appId : '222664514734026', xfbml : true, version : 'v6.0' }); FB.Event.subscribe('send_to_messenger', function(e) { var modal = window.top.document.getElementById('stamped-facebook-optin'); if (e.event == 'rendered'){ modal.style.display = 'block'; } if (e.event == 'opt_in'){ console.log('hide'); modal.style.display = 'none'; } }); }; (function(d, s, id){ var js, fjs = d.getElementsByTagName(s)[0]; if (d.getElementById(id)) {return;} js = d.createElement(s); js.id = id; js.src = '//connect.facebook.net/en_US/sdk.js'; fjs.parentNode.insertBefore(js, fjs); }(document, 'script', 'facebook-jssdk') ); <\/script> <body>" + t + "</body> </html>";
                        A.body.appendChild(a), P(a).appendTo("#stamped-facebook-optin .fb-send-to-messenger"), a.contentWindow.document.open(), a.contentWindow.document.write(s), a.contentWindow.document.close()
                    }
                }), clearInterval(a)), 5 <= ++t && clearInterval(a)
            }, 2e3)
        },
        closeSurveyOptin: function() {
            P("#stamped-facebook-optin").remove()
        },
        triggerEvent: Ke,
        on: function(e, t) {
            A.addEventListener ? A.addEventListener(e, t) : A.attachEvent("on" + e, function() {
                t.call(A)
            })
        },
        jQuery: P,
        stampedLog: Ee,
        getOptions: function() {
            return q
        },
        setOptions: function(e) {
            Object.assign(q, e)
        },
        getLoggedInCustomer: function() {
            return b.customer
        },
        getDataRewards: function() {
            return b
        },
        loadLauncherView: V,
        toggleLauncher: K,
        toggleRewardsModal: K,
        rewardsApplyCode: function(e) {
            var t = P(".stamped-reward-coupon-code", h).text(),
                a = P("#stamped-rewards-apply-code", h).text(),
                s = b.links;
            if (Q("loading"), 1 == (q.is_rewards_code_copy || -1 < a.indexOf("Copy"))) {
                var i = t,
                    r = A.createElement("span");
                r.appendChild(A.createTextNode(i)), r.id = "tempCopyToClipboard", A.body.append(r);
                var d = A.createRange();
                d.selectNode(r), L.getSelection().removeAllRanges(), L.getSelection().addRange(d), A.execCommand("copy"), L.getSelection().removeAllRanges(), r.remove(), Q("active")
            } else {
                var n = s.shop + "/discount/" + t;
                e && e.skip || P.ajax({
                    type: "GET",
                    url: n,
                    data: {},
                    success: function(e, t, a) {
                        Q("active")
                    }
                })
            }
            return {
                code: t,
                setState: Q
            }
        },
        rewardsReferralClaimCode: function() {
            var e = P("#referral_claim_email", h),
                t = P("#stamped-rewards-claim-code", h),
                a = e.val(),
                s = StampedFn.getOptions();
            a && (J(t, "loading", !0), P.ajax({
                type: "POST",
                url: s.SECURE_ENDPOINT + "/v2/rewards/referral/claim?" + P.param({
                    apiKey: L.StampedGlobalOptions.apiKey,
                    sId: L.StampedGlobalOptions.sId,
                    storeUrl: L.StampedGlobalOptions.storeUrl,
                    email: a,
                    referralCode: s.referral_code,
                    debug: null
                }),
                dataType: "json",
                success: function(e, t, a) {
                    console.log(e.data), V("view-coupon", null, {
                        couponCode: e.couponCode,
                        title: e.title,
                        viewTitle: e.title
                    })
                },
                error: function(e) {
                    var t = e.responseJSON.message;
                    P(".stamped-reward-card-error", h).text(t)
                },
                complete: function() {
                    J(t, "active", !0, 1e3)
                }
            }))
        },
        rewardsLink: function(e) {
            var t = b.links;
            "login" == e ? top.location.href = t.login : "signup" == e && (top.location.href = t.signup)
        },
        rewardsRedeem: W,
        rewardsPointsRefresh: M
    }
}(window, document);